module.exports.euAndEeaCountries = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

// Codes need to be compatible with https://docs.recurly.com/docs/countries-provinces-and-states#countries
module.exports.isoCodes = {
  Afghanistan: 'AF',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Angola: 'AO',
  Anguilla: 'AI',
  'Antigua and Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  'The Bahamas': 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bosnia and Herzegovina': 'BA',
  Botswana: 'BW',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  Brunei: 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  'Republic of the Congo': 'CG',
  'Democratic Republic of the Congo': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  'Ivory Coast': 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  Czechia: 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern and Antarctic Lands': 'TF',
  Gabon: 'GA',
  'The Gambia': 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island and McDonald Islands': 'HM',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  'North Korea': 'KP',
  'South Korea': 'KR',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Laos: 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macau: 'MO',
  'Republic of Macedonia': 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Isle of Man': 'IM',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  'Federated States of Micronesia': 'FM',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  'Pitcairn Islands': 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  Réunion: 'RE',
  Romania: 'RO',
  Russia: 'RU',
  Rwanda: 'RW',
  'Saint Helena': 'SH',
  'Saint Kitts and Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Pierre and Miquelon': 'PM',
  'Saint Vincent and the Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'São Tomé and Príncipe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia': 'GS',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard and Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  'East Timor': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad and Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Venezuela: 'VE',
  Vietnam: 'VN',
  'Wallis and Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};

module.exports.states = {
  Afghanistan: [
    'Badakhshan',
    'Badghis',
    'Baghlan',
    'Balkh',
    'Bamian',
    'Farah',
    'Faryab',
    'Ghazni',
    'Ghowr',
    'Helmand',
    'Herat',
    'Jowzjan',
    'Kabol',
    'Kandahar',
    'Kapisa',
    'Konar',
    'Kondoz',
    'Laghman',
    'Lowgar',
    'Nangarhar',
    'Nimruz',
    'Oruzgan',
    'Paktia',
    'Paktika',
    'Parvan',
    'Samangan',
    'Sar-e Pol',
    'Takhar',
    'Vardak',
    'Zabol',
  ],
  Albania: [
    'Berat',
    'Bulqize',
    'Delvine',
    'Devoll (Bilisht)',
    'Diber (Peshkopi)',
    'Durres',
    'Elbasan',
    'Fier',
    'Gjirokaster',
    'Gramsh',
    'Has (Krume)',
    'Kavaje',
    'Kolonje (Erseke)',
    'Korce',
    'Kruje',
    'Kucove',
    'Kukes',
    'Kurbin',
    'Lezhe',
    'Librazhd',
    'Lushnje',
    'Malesi e Madhe (Koplik)',
    'Mallakaster (Ballsh)',
    'Mat (Burrel)',
    'Mirdite (Rreshen)',
    'Peqin',
    'Permet',
    'Pogradec',
    'Puke',
    'Sarande',
    'Shkoder',
    'Skrapar (Corovode)',
    'Tepelene',
    'Tirane (Tirana)',
    'Tropoje (Bajram Curri)',
    'Vlore',
  ],
  Algeria: [
    'Adrar',
    'Ain Defla',
    'Ain Temouchent',
    'Alger',
    'Annaba',
    'Batna',
    'Bechar',
    'Bejaia',
    'Biskra',
    'Blida',
    'Bordj Bou Arreridj',
    'Bouira',
    'Boumerdes',
    'Chlef',
    'Constantine',
    'Djelfa',
    'El Bayadh',
    'El Oued',
    'El Tarf',
    'Ghardaia',
    'Guelma',
    'Illizi',
    'Jijel',
    'Khenchela',
    'Laghouat',
    "M'Sila",
    'Mascara',
    'Medea',
    'Mila',
    'Mostaganem',
    'Naama',
    'Oran',
    'Ouargla',
    'Oum el Bouaghi',
    'Relizane',
    'Saida',
    'Setif',
    'Sidi Bel Abbes',
    'Skikda',
    'Souk Ahras',
    'Tamanghasset',
    'Tebessa',
    'Tiaret',
    'Tindouf',
    'Tipaza',
    'Tissemsilt',
    'Tizi Ouzou',
    'Tlemcen',
  ],
  'American Samoa': [
    'Eastern',
    "Manu'a",
    'Rose Island',
    'Swains Island',
    'Western',
  ],
  Angola: [
    'Andorra la Vella',
    'Bengo',
    'Benguela',
    'Bie',
    'Cabinda',
    'Canillo',
    'Cuando Cubango',
    'Cuanza Norte',
    'Cuanza Sul',
    'Cunene',
    'Encamp',
    'Escaldes-Engordany',
    'Huambo',
    'Huila',
    'La Massana',
    'Luanda',
    'Lunda Norte',
    'Lunda Sul',
    'Malanje',
    'Moxico',
    'Namibe',
    'Ordino',
    'Sant Julia de Loria',
    'Uige',
    'Zaire',
  ],
  Anguilla: ['Anguilla'],
  'Antigua and Barbuda': [
    'Barbuda',
    'Redonda',
    'Saint George',
    'Saint John',
    'Saint Mary',
    'Saint Paul',
    'Saint Peter',
    'Saint Philip',
  ],
  Argentina: [
    'Antartica e Islas del Atlantico Sur',
    'Buenos Aires',
    'Buenos Aires Capital Federal',
    'Catamarca',
    'Chaco',
    'Chubut',
    'Cordoba',
    'Corrientes',
    'Entre Rios',
    'Formosa',
    'Jujuy',
    'La Pampa',
    'La Rioja',
    'Mendoza',
    'Misiones',
    'Neuquen',
    'Rio Negro',
    'Salta',
    'San Juan',
    'San Luis',
    'Santa Cruz',
    'Santa Fe',
    'Santiago del Estero',
    'Tierra del Fuego',
    'Tucuman',
  ],
  Armenia: [
    'Aragatsotn',
    'Ararat',
    'Armavir',
    "Geghark'unik'",
    "Kotayk'",
    'Lorri',
    'Shirak',
    "Syunik'",
    'Tavush',
    "Vayots' Dzor",
    'Yerevan',
  ],
  Aruba: ['Aruba'],
  Australia: [
    'Australian Capital Territory',
    'New South Wales',
    'Northern Territory',
    'Queensland',
    'South Australia',
    'Tasmania',
    'Victoria',
    'Western Australia',
  ],
  Austria: [
    'Burgenland',
    'Kaernten',
    'Niederoesterreich',
    'Oberoesterreich',
    'Salzburg',
    'Steiermark',
    'Tirol',
    'Vorarlberg',
    'Wien',
  ],
  Azerbaijan: [
    'Abseron Rayonu',
    'Agcabadi Rayonu',
    'Agdam Rayonu',
    'Agdas Rayonu',
    'Agstafa Rayonu',
    'Agsu Rayonu',
    'Ali Bayramli Sahari',
    'Astara Rayonu',
    'Baki Sahari',
    'Balakan Rayonu',
    'Barda Rayonu',
    'Beylaqan Rayonu',
    'Bilasuvar Rayonu',
    'Cabrayil Rayonu',
    'Calilabad Rayonu',
    'Daskasan Rayonu',
    'Davaci Rayonu',
    'Fuzuli Rayonu',
    'Gadabay Rayonu',
    'Ganca Sahari',
    'Goranboy Rayonu',
    'Goycay Rayonu',
    'Haciqabul Rayonu',
    'Imisli Rayonu',
    'Ismayilli Rayonu',
    'Kalbacar Rayonu',
    'Kurdamir Rayonu',
    'Lacin Rayonu',
    'Lankaran Rayonu',
    'Lankaran Sahari',
    'Lerik Rayonu',
    'Masalli Rayonu',
    'Mingacevir Sahari',
    'Naftalan Sahari',
    'Naxcivan Muxtar Respublikasi',
    'Neftcala Rayonu',
    'Oguz Rayonu',
    'Qabala Rayonu',
    'Qax Rayonu',
    'Qazax Rayonu',
    'Qobustan Rayonu',
    'Quba Rayonu',
    'Qubadli Rayonu',
    'Qusar Rayonu',
    'Saatli Rayonu',
    'Sabirabad Rayonu',
    'Saki Rayonu',
    'Saki Sahari',
    'Salyan Rayonu',
    'Samaxi Rayonu',
    'Samkir Rayonu',
    'Samux Rayonu',
    'Siyazan Rayonu',
    'Sumqayit Sahari',
    'Susa Rayonu',
    'Susa Sahari',
    'Tartar Rayonu',
    'Tovuz Rayonu',
    'Ucar Rayonu',
    'Xacmaz Rayonu',
    'Xankandi Sahari',
    'Xanlar Rayonu',
    'Xizi Rayonu',
    'Xocali Rayonu',
    'Xocavand Rayonu',
    'Yardimli Rayonu',
    'Yevlax Rayonu',
    'Yevlax Sahari',
    'Zangilan Rayonu',
    'Zaqatala Rayonu',
    'Zardab Rayonu',
  ],
  'The Bahamas': [
    'Acklins and Crooked Islands',
    'Bimini',
    'Cat Island',
    'Exuma',
    'Freeport',
    'Fresh Creek',
    "Governor's Harbour",
    'Green Turtle Cay',
    'Harbour Island',
    'High Rock',
    'Inagua',
    'Kemps Bay',
    'Long Island',
    'Marsh Harbour',
    'Mayaguana',
    'New Providence',
    'Nicholls Town and Berry Islands',
    'Ragged Island',
    'Rock Sound',
    'San Salvador and Rum Cay',
    'Sandy Point',
  ],
  Bahrain: [
    'Al Hadd',
    'Al Manamah',
    'Al Mintaqah al Gharbiyah',
    'Al Mintaqah al Wusta',
    'Al Mintaqah ash Shamaliyah',
    'Al Muharraq',
    "Ar Rifa' wa al Mintaqah al Janubiyah",
    'Jidd Hafs',
    'Juzur Hawar',
    "Madinat 'Isa",
    'Madinat Hamad',
    'Sitrah',
  ],
  Bangladesh: [
    'Barisal',
    'Chittagong',
    'Dhaka',
    'Mymensingh',
    'Khulna',
    'Rajshahi',
    'Rangpur',
    'Sylhet',
  ],
  Barbados: [
    'Bridgetown',
    'Christ Church',
    'Saint Andrew',
    'Saint George',
    'Saint James',
    'Saint John',
    'Saint Joseph',
    'Saint Lucy',
    'Saint Michael',
    'Saint Peter',
    'Saint Philip',
    'Saint Thomas',
  ],
  Belarus: [
    'Brestskaya (Brest)',
    "Homyel'skaya (Homyel')",
    'Horad Minsk',
    'Hrodzyenskaya (Hrodna)',
    'Mahilyowskaya (Mahilyow)',
    'Minskaya',
    'Vitsyebskaya (Vitsyebsk)',
  ],
  Belgium: [
    'Antwerpen',
    'Brabant Wallon',
    'Brussels Capitol Region',
    'Hainaut',
    'Liege',
    'Limburg',
    'Luxembourg',
    'Namur',
    'Oost-Vlaanderen',
    'Vlaams Brabant',
    'West-Vlaanderen',
  ],
  Belize: ['Belize', 'Cayo', 'Corozal', 'Orange Walk', 'Stann Creek', 'Toledo'],
  Benin: [
    'Alibori',
    'Atakora',
    'Atlantique',
    'Borgou',
    'Collines',
    'Couffo',
    'Donga',
    'Littoral',
    'Mono',
    'Oueme',
    'Plateau',
    'Zou',
  ],
  Bermuda: [
    'Devonshire',
    'Hamilton',
    'Hamilton',
    'Paget',
    'Pembroke',
    'Saint George',
    'Saint Georges',
    'Sandys',
    'Smiths',
    'Southampton',
    'Warwick',
  ],
  Bhutan: [
    'Bumthang',
    'Chhukha',
    'Chirang',
    'Daga',
    'Geylegphug',
    'Ha',
    'Lhuntshi',
    'Mongar',
    'Paro',
    'Pemagatsel',
    'Punakha',
    'Samchi',
    'Samdrup Jongkhar',
    'Shemgang',
    'Tashigang',
    'Thimphu',
    'Tongsa',
    'Wangdi Phodrang',
  ],
  Bolivia: [
    'Beni',
    'Chuquisaca',
    'Cochabamba',
    'La Paz',
    'Oruro',
    'Pando',
    'Potosi',
    'Santa Cruz',
    'Tarija',
  ],
  'Bosnia and Herzegovina': [
    'Federation of Bosnia and Herzegovina',
    'Republika Srpska',
  ],
  Botswana: [
    'Central',
    'Chobe',
    'Francistown',
    'Gaborone',
    'Ghanzi',
    'Kgalagadi',
    'Kgatleng',
    'Kweneng',
    'Lobatse',
    'Ngamiland',
    'North-East',
    'Selebi-Pikwe',
    'South-East',
    'Southern',
  ],
  Brazil: [
    'Acre',
    'Alagoas',
    'Amapa',
    'Amazonas',
    'Bahia',
    'Ceara',
    'Distrito Federal',
    'Espirito Santo',
    'Goias',
    'Maranhao',
    'Mato Grosso',
    'Mato Grosso do Sul',
    'Minas Gerais',
    'Para',
    'Paraiba',
    'Parana',
    'Pernambuco',
    'Piaui',
    'Rio de Janeiro',
    'Rio Grande do Norte',
    'Rio Grande do Sul',
    'Rondonia',
    'Roraima',
    'Santa Catarina',
    'Sao Paulo',
    'Sergipe',
    'Tocantins',
  ],
  'British Indian Ocean Territory': [
    'Anegada',
    'Jost Van Dyke',
    'Tortola',
    'Virgin Gorda',
  ],
  Brunei: ['Belait', 'Brunei and Muara', 'Temburong', 'Tutong'],
  Bulgaria: [
    'Blagoevgrad',
    'Burgas',
    'Dobrich',
    'Gabrovo',
    'Khaskovo',
    'Kurdzhali',
    'Kyustendil',
    'Lovech',
    'Montana',
    'Pazardzhik',
    'Pernik',
    'Pleven',
    'Plovdiv',
    'Razgrad',
    'Ruse',
    'Shumen',
    'Silistra',
    'Sliven',
    'Smolyan',
    'Sofiya',
    'Sofiya-Grad',
    'Stara Zagora',
    'Turgovishte',
    'Varna',
    'Veliko Turnovo',
    'Vidin',
    'Vratsa',
    'Yambol',
  ],
  'Burkina Faso': [
    'Bale',
    'Bam',
    'Banwa',
    'Bazega',
    'Bougouriba',
    'Boulgou',
    'Boulkiemde',
    'Comoe',
    'Ganzourgou',
    'Gnagna',
    'Gourma',
    'Houet',
    'Ioba',
    'Kadiogo',
    'Kenedougou',
    'Komandjari',
    'Kompienga',
    'Kossi',
    'Koupelogo',
    'Kouritenga',
    'Kourweogo',
    'Leraba',
    'Loroum',
    'Mouhoun',
    'Nahouri',
    'Namentenga',
    'Naumbiel',
    'Nayala',
    'Oubritenga',
    'Oudalan',
    'Passore',
    'Poni',
    'Samentenga',
    'Sanguie',
    'Seno',
    'Sissili',
    'Soum',
    'Sourou',
    'Tapoa',
    'Tuy',
    'Yagha',
    'Yatenga',
    'Ziro',
    'Zondomo',
    'Zoundweogo',
  ],
  Burundi: [
    'Bubanza',
    'Bujumbura',
    'Bururi',
    'Cankuzo',
    'Cibitoke',
    'Gitega',
    'Karuzi',
    'Kayanza',
    'Kirundo',
    'Makamba',
    'Muramvya',
    'Muyinga',
    'Mwaro',
    'Ngozi',
    'Rutana',
    'Ruyigi',
  ],
  Cambodia: [
    'Banteay Mean Cheay',
    'Batdambang',
    'Kampong Cham',
    'Kampong Chhnang',
    'Kampong Spoe',
    'Kampong Thum',
    'Kampot',
    'Kandal',
    'Kaoh Kong',
    'Keb',
    'Kracheh',
    'Mondol Kiri',
    'Otdar Mean Cheay',
    'Pailin',
    'Phnum Penh',
    'Pouthisat',
    'Preah Seihanu (Sihanoukville)',
    'Preah Vihear',
    'Prey Veng',
    'Rotanah Kiri',
    'Siem Reab',
    'Stoeng Treng',
    'Svay Rieng',
    'Takev',
  ],
  Cameroon: [
    'Adamaoua',
    'Centre',
    'Est',
    'Extreme-Nord',
    'Littoral',
    'Nord',
    'Nord-Ouest',
    'Ouest',
    'Sud',
    'Sud-Ouest',
  ],
  Canada: [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon Territory',
  ],
  'Cape Verde': [
    'Boa Vista',
    'Brava',
    'Maio',
    'Mosteiros',
    'Paul',
    'Porto Novo',
    'Praia',
    'Ribeira Grande',
    'Sal',
    'Santa Catarina',
    'Santa Cruz',
    'Sao Domingos',
    'Sao Filipe',
    'Sao Nicolau',
    'Sao Vicente',
    'Tarrafal',
  ],
  'Cayman Islands': [
    'Creek',
    'Eastern',
    'Midland',
    'South Town',
    'Spot Bay',
    'Stake Bay',
    'West End',
    'Western',
  ],
  'Central African Republic': [
    'Bamingui-Bangoran',
    'Bangui',
    'Basse-Kotto',
    'Gribingui',
    'Haut-Mbomou',
    'Haute-Kotto',
    'Haute-Sangha',
    'Kemo-Gribingui',
    'Lobaye',
    'Mbomou',
    'Nana-Mambere',
    'Ombella-Mpoko',
    'Ouaka',
    'Ouham',
    'Ouham-Pende',
    'Sangha',
    'Vakaga',
  ],
  Chad: [
    'Batha',
    'Biltine',
    'Borkou-Ennedi-Tibesti',
    'Chari-Baguirmi',
    'Guera',
    'Kanem',
    'Lac',
    'Logone Occidental',
    'Logone Oriental',
    'Mayo-Kebbi',
    'Moyen-Chari',
    'Ouaddai',
    'Salamat',
    'Tandjile',
  ],
  Chile: [
    'Aisen del General Carlos Ibanez del Campo',
    'Antofagasta',
    'Araucania',
    'Atacama',
    'Bio-Bio',
    'Coquimbo',
    "Libertador General Bernardo O'Higgins",
    'Los Lagos',
    'Magallanes y de la Antartica Chilena',
    'Maule',
    'Region Metropolitana (Santiago)',
    'Tarapaca',
    'Valparaiso',
  ],
  China: [
    'Anhui',
    'Beijing',
    'Chongqing',
    'Fujian',
    'Gansu',
    'Guangdong',
    'Guangxi',
    'Guizhou',
    'Hainan',
    'Hebei',
    'Heilongjiang',
    'Henan',
    'Hubei',
    'Hunan',
    'Jiangsu',
    'Jiangxi',
    'Jilin',
    'Liaoning',
    'Nei Mongol',
    'Ningxia',
    'Qinghai',
    'Shaanxi',
    'Shandong',
    'Shanghai',
    'Shanxi',
    'Sichuan',
    'Tianjin',
    'Xinjiang',
    'Xizang (Tibet)',
    'Yunnan',
    'Zhejiang',
  ],
  'Christmas Island': ['Christmas Island'],
  'Cocos (Keeling) Islands': [
    'Direction Island',
    'Home Island',
    'Horsburgh Island',
    'North Keeling Island',
    'South Island',
    'West Island',
  ],
  Colombia: [
    'Amazonas',
    'Antioquia',
    'Arauca',
    'Atlantico',
    'Bolivar',
    'Boyaca',
    'Caldas',
    'Caqueta',
    'Casanare',
    'Cauca',
    'Cesar',
    'Choco',
    'Cordoba',
    'Cundinamarca',
    'Distrito Capital de Santa Fe de Bogota',
    'Guainia',
    'Guaviare',
    'Huila',
    'La Guajira',
    'Magdalena',
    'Meta',
    'Narino',
    'Norte de Santander',
    'Putumayo',
    'Quindio',
    'Risaralda',
    'San Andres y Providencia',
    'Santander',
    'Sucre',
    'Tolima',
    'Valle del Cauca',
    'Vaupes',
    'Vichada',
  ],
  Comoros: [
    'Anjouan (Nzwani)',
    'Domoni',
    'Fomboni',
    'Grande Comore (Njazidja)',
    'Moheli (Mwali)',
    'Moroni',
    'Moutsamoudou',
  ],
  'Republic of the Congo': [
    'Bandundu',
    'Bas-Congo',
    'Equateur',
    'Kasai-Occidental',
    'Kasai-Oriental',
    'Katanga',
    'Kinshasa',
    'Maniema',
    'Nord-Kivu',
    'Orientale',
    'Sud-Kivu',
  ],
  'Democratic Republic of the Congo': [
    'Bouenza',
    'Brazzaville',
    'Cuvette',
    'Kouilou',
    'Lekoumou',
    'Likouala',
    'Niari',
    'Plateaux',
    'Pool',
    'Sangha',
  ],
  'Cook Islands': [
    'Aitutaki',
    'Atiu',
    'Avarua',
    'Mangaia',
    'Manihiki',
    'Manuae',
    'Mauke',
    'Mitiaro',
    'Nassau Island',
    'Palmerston',
    'Penrhyn',
    'Pukapuka',
    'Rakahanga',
    'Rarotonga',
    'Suwarrow',
    'Takutea',
  ],
  'Costa Rica': [
    'Alajuela',
    'Cartago',
    'Guanacaste',
    'Heredia',
    'Limon',
    'Puntarenas',
    'San Jose',
  ],
  'Ivory Coast': [
    'Abengourou',
    'Abidjan',
    'Aboisso',
    "Adiake'",
    'Adzope',
    'Agboville',
    'Agnibilekrou',
    "Ale'pe'",
    'Bangolo',
    'Beoumi',
    'Biankouma',
    'Bocanda',
    'Bondoukou',
    'Bongouanou',
    'Bouafle',
    'Bouake',
    'Bouna',
    'Boundiali',
    'Dabakala',
    'Dabon',
    'Daloa',
    'Danane',
    'Daoukro',
    'Dimbokro',
    'Divo',
    'Duekoue',
    'Ferkessedougou',
    'Gagnoa',
    'Grand Bassam',
    'Grand-Lahou',
    'Guiglo',
    'Issia',
    'Jacqueville',
    'Katiola',
    'Korhogo',
    'Lakota',
    'Man',
    'Mankono',
    'Mbahiakro',
    'Odienne',
    'Oume',
    'Sakassou',
    'San-Pedro',
    'Sassandra',
    'Seguela',
    'Sinfra',
    'Soubre',
    'Tabou',
    'Tanda',
    'Tiassale',
    'Tiebissou',
    'Tingrela',
    'Touba',
    'Toulepleu',
    'Toumodi',
    'Vavoua',
    'Yamoussoukro',
    'Zuenoula',
  ],
  Croatia: [
    'Bjelovarsko-Bilogorska Zupanija',
    'Brodsko-Posavska Zupanija',
    'Dubrovacko-Neretvanska Zupanija',
    'Istarska Zupanija',
    'Karlovacka Zupanija',
    'Koprivnicko-Krizevacka Zupanija',
    'Krapinsko-Zagorska Zupanija',
    'Licko-Senjska Zupanija',
    'Medimurska Zupanija',
    'Osjecko-Baranjska Zupanija',
    'Pozesko-Slavonska Zupanija',
    'Primorsko-Goranska Zupanija',
    'Sibensko-Kninska Zupanija',
    'Sisacko-Moslavacka Zupanija',
    'Splitsko-Dalmatinska Zupanija',
    'Varazdinska Zupanija',
    'Viroviticko-Podravska Zupanija',
    'Vukovarsko-Srijemska Zupanija',
    'Zadarska Zupanija',
    'Zagreb',
    'Zagrebacka Zupanija',
  ],
  Cuba: [
    'Camaguey',
    'Ciego de Avila',
    'Cienfuegos',
    'Ciudad de La Habana',
    'Granma',
    'Guantanamo',
    'Holguin',
    'Isla de la Juventud',
    'La Habana',
    'Las Tunas',
    'Matanzas',
    'Pinar del Rio',
    'Sancti Spiritus',
    'Santiago de Cuba',
    'Villa Clara',
  ],
  Cyprus: ['Famagusta', 'Kyrenia', 'Larnaca', 'Limassol', 'Nicosia', 'Paphos'],
  'Czech Republic': [
    'Brnensky',
    'Budejovicky',
    'Jihlavsky',
    'Karlovarsky',
    'Kralovehradecky',
    'Liberecky',
    'Olomoucky',
    'Ostravsky',
    'Pardubicky',
    'Plzensky',
    'Praha',
    'Stredocesky',
    'Ustecky',
    'Zlinsky',
  ],
  Czechia: [
    'Brnensky',
    'Budejovicky',
    'Jihlavsky',
    'Karlovarsky',
    'Kralovehradecky',
    'Liberecky',
    'Olomoucky',
    'Ostravsky',
    'Pardubicky',
    'Plzensky',
    'Praha',
    'Stredocesky',
    'Ustecky',
    'Zlinsky',
  ],
  Denmark: [
    'Arhus',
    'Bornholm',
    'Fredericksberg',
    'Frederiksborg',
    'Fyn',
    'Kobenhavn',
    'Kobenhavns',
    'Nordjylland',
    'Ribe',
    'Ringkobing',
    'Roskilde',
    'Sonderjylland',
    'Storstrom',
    'Vejle',
    'Vestsjalland',
    'Viborg',
  ],
  Djibouti: ["'Ali Sabih", 'Dikhil', 'Djibouti', 'Obock', 'Tadjoura'],
  Dominica: [
    'Saint Andrew',
    'Saint David',
    'Saint George',
    'Saint John',
    'Saint Joseph',
    'Saint Luke',
    'Saint Mark',
    'Saint Patrick',
    'Saint Paul',
    'Saint Peter',
  ],
  'Dominican Republic': [
    'Azua',
    'Baoruco',
    'Barahona',
    'Dajabon',
    'Distrito Nacional',
    'Duarte',
    'El Seibo',
    'Elias Pina',
    'Espaillat',
    'Hato Mayor',
    'Independencia',
    'La Altagracia',
    'La Romana',
    'La Vega',
    'Maria Trinidad Sanchez',
    'Monsenor Nouel',
    'Monte Cristi',
    'Monte Plata',
    'Pedernales',
    'Peravia',
    'Puerto Plata',
    'Salcedo',
    'Samana',
    'San Cristobal',
    'San Juan',
    'San Pedro de Macoris',
    'Sanchez Ramirez',
    'Santiago',
    'Santiago Rodriguez',
    'Valverde',
  ],
  Ecuador: [
    'Azuay',
    'Bolivar',
    'Canar',
    'Carchi',
    'Chimborazo',
    'Cotopaxi',
    'El Oro',
    'Esmeraldas',
    'Galapagos',
    'Guayas',
    'Imbabura',
    'Loja',
    'Los Rios',
    'Manabi',
    'Morona-Santiago',
    'Napo',
    'Orellana',
    'Pastaza',
    'Pichincha',
    'Sucumbios',
    'Tungurahua',
    'Zamora-Chinchipe',
  ],
  Egypt: [
    'Ad Daqahliyah',
    'Al Bahr al Ahmar',
    'Al Buhayrah',
    'Al Fayyum',
    'Al Gharbiyah',
    'Al Iskandariyah',
    "Al Isma'iliyah",
    'Al Jizah',
    'Al Minufiyah',
    'Al Minya',
    'Al Qahirah',
    'Al Qalyubiyah',
    'Al Wadi al Jadid',
    'As Suways',
    'Ash Sharqiyah',
    'Aswan',
    'Asyut',
    'Bani Suwayf',
    "Bur Sa'id",
    'Dumyat',
    "Janub Sina'",
    'Kafr ash Shaykh',
    'Matruh',
    'Qina',
    "Shamal Sina'",
    'Suhaj',
  ],
  'El Salvador': [
    'Ahuachapan',
    'Cabanas',
    'Chalatenango',
    'Cuscatlan',
    'La Libertad',
    'La Paz',
    'La Union',
    'Morazan',
    'San Miguel',
    'San Salvador',
    'San Vicente',
    'Santa Ana',
    'Sonsonate',
    'Usulutan',
  ],
  'Equatorial Guinea': [
    'Annobon',
    'Bioko Norte',
    'Bioko Sur',
    'Centro Sur',
    'Kie-Ntem',
    'Litoral',
    'Wele-Nzas',
  ],
  Eritrea: [
    'Akale Guzay',
    'Barka',
    'Denkel',
    'Hamasen',
    'Sahil',
    'Semhar',
    'Senhit',
    'Seraye',
  ],
  Estonia: [
    'Harjumaa (Tallinn)',
    'Hiiumaa (Kardla)',
    'Ida-Virumaa (Johvi)',
    'Jarvamaa (Paide)',
    'Jogevamaa (Jogeva)',
    'Laane-Virumaa (Rakvere)',
    'Laanemaa (Haapsalu)',
    'Parnumaa (Parnu)',
    'Polvamaa (Polva)',
    'Raplamaa (Rapla)',
    'Saaremaa (Kuessaare)',
    'Tartumaa (Tartu)',
    'Valgamaa (Valga)',
    'Viljandimaa (Viljandi)',
    'Vorumaa (Voru)',
  ],
  Ethiopia: [
    'Adis Abeba (Addis Ababa)',
    'Afar',
    'Amara',
    'Dire Dawa',
    'Gambela Hizboch',
    'Hareri Hizb',
    'Oromiya',
    'Sumale',
    'Tigray',
    'YeDebub Biheroch Bihereseboch na Hizboch',
  ],
  'Falkland Islands': ['Falkland Islands (Islas Malvinas)'],
  'Faroe Islands': [
    'Bordoy',
    'Eysturoy',
    'Mykines',
    'Sandoy',
    'Skuvoy',
    'Streymoy',
    'Suduroy',
    'Tvoroyri',
    'Vagar',
  ],
  Fiji: ['Central', 'Eastern', 'Northern', 'Rotuma', 'Western'],
  Finland: [
    'Aland',
    'Etela-Suomen Laani',
    'Ita-Suomen Laani',
    'Lansi-Suomen Laani',
    'Lappi',
    'Oulun Laani',
  ],
  France: [
    'Alsace',
    'Aquitaine',
    'Auvergne',
    'Basse-Normandie',
    'Bourgogne',
    'Bretagne',
    'Centre',
    'Champagne-Ardenne',
    'Corse',
    'Franche-Comte',
    'Haute-Normandie',
    'Ile-de-France',
    'Languedoc-Roussillon',
    'Limousin',
    'Lorraine',
    'Midi-Pyrenees',
    'Nord-Pas-de-Calais',
    'Pays de la Loire',
    'Picardie',
    'Poitou-Charentes',
    "Provence-Alpes-Cote d'Azur",
    'Rhone-Alpes',
  ],
  'French Guiana': ['French Guiana'],
  'French Polynesia': [
    'Archipel des Marquises',
    'Archipel des Tuamotu',
    'Archipel des Tubuai',
    'Iles du Vent',
    'Iles Sous-le-Vent',
  ],
  'French Southern and Antarctic Lands': [
    'Adelie Land',
    'Ile Crozet',
    'Iles Kerguelen',
    'Iles Saint-Paul et Amsterdam',
  ],
  Gabon: [
    'Estuaire',
    'Haut-Ogooue',
    'Moyen-Ogooue',
    'Ngounie',
    'Nyanga',
    'Ogooue-Ivindo',
    'Ogooue-Lolo',
    'Ogooue-Maritime',
    'Woleu-Ntem',
  ],
  'The Gambia': [
    'Banjul',
    'Central River',
    'Lower River',
    'North Bank',
    'Upper River',
    'Western',
  ],
  Georgia: [
    'Abashis',
    "Abkhazia or Ap'khazet'is Avtonomiuri Respublika (Sokhumi)",
    'Adigenis',
    "Ajaria or Acharis Avtonomiuri Respublika (Bat'umi)",
    'Akhalgoris',
    "Akhalk'alak'is",
    "Akhalts'ikhis",
    'Akhmetis',
    'Ambrolauris',
    'Aspindzis',
    "Baghdat'is",
    'Bolnisis',
    'Borjomis',
    "Ch'khorotsqus",
    "Ch'okhatauris",
    "Chiat'ura",
    "Dedop'listsqaros",
    'Dmanisis',
    "Dushet'is",
    'Gardabanis',
    'Gori',
    'Goris',
    'Gurjaanis',
    'Javis',
    "K'arelis",
    "K'ut'aisi",
    'Kaspis',
    'Kharagaulis',
    'Khashuris',
    'Khobis',
    'Khonis',
    'Lagodekhis',
    "Lanch'khut'is",
    'Lentekhis',
    'Marneulis',
    'Martvilis',
    'Mestiis',
    "Mts'khet'is",
    'Ninotsmindis',
    'Onis',
    "Ozurget'is",
    "P'ot'i",
    'Qazbegis',
    'Qvarlis',
    "Rust'avi",
    "Sach'kheris",
    'Sagarejos',
    'Samtrediis',
    'Senakis',
    'Sighnaghis',
    "T'bilisi",
    "T'elavis",
    "T'erjolis",
    "T'et'ritsqaros",
    "T'ianet'is",
    'Tqibuli',
    "Ts'ageris",
    'Tsalenjikhis',
    'Tsalkis',
    'Tsqaltubo',
    'Vanis',
    "Zestap'onis",
    'Zugdidi',
    'Zugdidis',
  ],
  Germany: [
    'Baden-Wuerttemberg',
    'Bayern',
    'Berlin',
    'Brandenburg',
    'Bremen',
    'Hamburg',
    'Hessen',
    'Mecklenburg-Vorpommern',
    'Niedersachsen',
    'Nordrhein-Westfalen',
    'Rheinland-Pfalz',
    'Saarland',
    'Sachsen',
    'Sachsen-Anhalt',
    'Schleswig-Holstein',
    'Thueringen',
  ],
  Ghana: [
    'Ashanti',
    'Brong-Ahafo',
    'Central',
    'Eastern',
    'Greater Accra',
    'Northern',
    'Upper East',
    'Upper West',
    'Volta',
    'Western',
  ],
  Gibraltar: ['Gibraltar'],
  Greece: [
    'Aitolia kai Akarnania',
    'Akhaia',
    'Argolis',
    'Arkadhia',
    'Arta',
    'Attiki',
    'Ayion Oros (Mt. Athos)',
    'Dhodhekanisos',
    'Drama',
    'Evritania',
    'Evros',
    'Evvoia',
    'Florina',
    'Fokis',
    'Fthiotis',
    'Grevena',
    'Ilia',
    'Imathia',
    'Ioannina',
    'Irakleion',
    'Kardhitsa',
    'Kastoria',
    'Kavala',
    'Kefallinia',
    'Kerkyra',
    'Khalkidhiki',
    'Khania',
    'Khios',
    'Kikladhes',
    'Kilkis',
    'Korinthia',
    'Kozani',
    'Lakonia',
    'Larisa',
    'Lasithi',
    'Lesvos',
    'Levkas',
    'Magnisia',
    'Messinia',
    'Pella',
    'Pieria',
    'Preveza',
    'Rethimni',
    'Rodhopi',
    'Samos',
    'Serrai',
    'Thesprotia',
    'Thessaloniki',
    'Trikala',
    'Voiotia',
    'Xanthi',
    'Zakinthos',
  ],
  Greenland: [
    'Avannaa (Nordgronland)',
    'Kitaa (Vestgronland)',
    'Tunu (Ostgronland)',
  ],
  Grenada: [
    'Carriacou and Petit Martinique',
    'Saint Andrew',
    'Saint David',
    'Saint George',
    'Saint John',
    'Saint Mark',
    'Saint Patrick',
  ],
  Guadeloupe: [
    'Basse-Terre',
    'Grande-Terre',
    'Iles de la Petite Terre',
    'Iles des Saintes',
    'Marie-Galante',
  ],
  Guam: ['Guam'],
  Guatemala: [
    'Alta Verapaz',
    'Baja Verapaz',
    'Chimaltenango',
    'Chiquimula',
    'El Progreso',
    'Escuintla',
    'Guatemala',
    'Huehuetenango',
    'Izabal',
    'Jalapa',
    'Jutiapa',
    'Peten',
    'Quetzaltenango',
    'Quiche',
    'Retalhuleu',
    'Sacatepequez',
    'San Marcos',
    'Santa Rosa',
    'Solola',
    'Suchitepequez',
    'Totonicapan',
    'Zacapa',
  ],
  Guernsey: [
    'Castel',
    'Forest',
    'St. Andrew',
    'St. Martin',
    'St. Peter Port',
    'St. Pierre du Bois',
    'St. Sampson',
    'St. Saviour',
    'Torteval',
    'Vale',
  ],
  Guinea: [
    'Beyla',
    'Boffa',
    'Boke',
    'Conakry',
    'Coyah',
    'Dabola',
    'Dalaba',
    'Dinguiraye',
    'Dubreka',
    'Faranah',
    'Forecariah',
    'Fria',
    'Gaoual',
    'Gueckedou',
    'Kankan',
    'Kerouane',
    'Kindia',
    'Kissidougou',
    'Koubia',
    'Koundara',
    'Kouroussa',
    'Labe',
    'Lelouma',
    'Lola',
    'Macenta',
    'Mali',
    'Mamou',
    'Mandiana',
    'Nzerekore',
    'Pita',
    'Siguiri',
    'Telimele',
    'Tougue',
    'Yomou',
  ],
  'Guinea-Bissau': [
    'Bafata',
    'Biombo',
    'Bissau',
    'Bolama-Bijagos',
    'Cacheu',
    'Gabu',
    'Oio',
    'Quinara',
    'Tombali',
  ],
  Guyana: [
    'Barima-Waini',
    'Cuyuni-Mazaruni',
    'Demerara-Mahaica',
    'East Berbice-Corentyne',
    'Essequibo Islands-West Demerara',
    'Mahaica-Berbice',
    'Pomeroon-Supenaam',
    'Potaro-Siparuni',
    'Upper Demerara-Berbice',
    'Upper Takutu-Upper Essequibo',
  ],
  Haiti: [
    'Artibonite',
    'Centre',
    "Grand'Anse",
    'Nord',
    'Nord-Est',
    'Nord-Ouest',
    'Ouest',
    'Sud',
    'Sud-Est',
  ],
  'Heard Island and McDonald Islands': ['Heard Island and McDonald Islands'],
  Honduras: [
    'Atlantida',
    'Choluteca',
    'Colon',
    'Comayagua',
    'Copan',
    'Cortes',
    'El Paraiso',
    'Francisco Morazan',
    'Gracias a Dios',
    'Intibuca',
    'Islas de la Bahia',
    'La Paz',
    'Lempira',
    'Ocotepeque',
    'Olancho',
    'Santa Barbara',
    'Valle',
    'Yoro',
  ],
  'Hong Kong': ['Hong Kong'],
  Hungary: [
    'Baranya',
    'Borsod-Abaúj-Zemplén',
    'Budapest',
    'Bács-Kiskun',
    'Békés',
    'Békéscsaba',
    'Csongrád-Csanád',
    'Debrecen',
    'Dunaújváros',
    'Eger',
    'Fejér',
    'Győr',
    'Győr-Moson-Sopron',
    'Hajdú-Bihar',
    'Heves',
    'Hódmezővásárhely',
    'Jász-Nagykun-Szolnok',
    'Kaposvár',
    'Kecskemét',
    'Komárom-Esztergom',
    'Miskolc',
    'Nagykanizsa',
    'Nyíregyháza',
    'Nógrád',
    'Pest',
    'Pécs',
    'Salgótarján',
    'Somogy',
    'Sopron',
    'Szabolcs-Szatmár-Bereg',
    'Szeged',
    'Szekszárd',
    'Szolnok',
    'Szombathely',
    'Székesfehérvár',
    'Tatabánya',
    'Tolna',
    'Vas',
    'Veszprém',
    'Veszprém',
    'Zala',
    'Zalaegerszeg',
    'Érd',
  ],
  Iceland: [
    'Akranes',
    'Akureyri',
    'Arnessysla',
    'Austur-Bardhastrandarsysla',
    'Austur-Hunavatnssysla',
    'Austur-Skaftafellssysla',
    'Borgarfjardharsysla',
    'Dalasysla',
    'Eyjafjardharsysla',
    'Gullbringusysla',
    'Hafnarfjordhur',
    'Husavik',
    'Isafjordhur',
    'Keflavik',
    'Kjosarsysla',
    'Kopavogur',
    'Myrasysla',
    'Neskaupstadhur',
    'Nordhur-Isafjardharsysla',
    'Nordhur-Mulasys-la',
    'Nordhur-Thingeyjarsysla',
    'Olafsfjordhur',
    'Rangarvallasysla',
    'Reykjavik',
    'Saudharkrokur',
    'Seydhisfjordhur',
    'Siglufjordhur',
    'Skagafjardharsysla',
    'Snaefellsnes-og Hnappadalssysla',
    'Strandasysla',
    'Sudhur-Mulasysla',
    'Sudhur-Thingeyjarsysla',
    'Vesttmannaeyjar',
    'Vestur-Bardhastrandarsysla',
    'Vestur-Hunavatnssysla',
    'Vestur-Isafjardharsysla',
    'Vestur-Skaftafellssysla',
  ],
  India: [
    'Andaman and Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Lakshadweep',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Puducherry',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
  ],
  Indonesia: [
    'Aceh',
    'Bali',
    'Banten',
    'Bengkulu',
    'Gorontalo',
    'Jakarta',
    'Jambi',
    'Jawa Barat',
    'Jawa Tengah',
    'Jawa Timur',
    'Kalimantan Barat',
    'Kalimantan Selatan',
    'Kalimantan Tengah',
    'Kalimantan Timur',
    'Kalimantan Utara',
    'Kepulauan Bangka Belitung',
    'Kepulauan Riau',
    'Lampung',
    'Maluku',
    'Maluku Utara',
    'Nusa Tenggara Barat',
    'Nusa Tenggara Timur',
    'Papua',
    'Papua Barat',
    'Riau',
    'Sulawesi Barat',
    'Sulawesi Selatan',
    'Sulawesi Tengah',
    'Sulawesi Utara',
    'Sumatera Barat',
    'Sumatera Selatan',
    'Sumatera Utara',
    'Yogyakarta',
  ],
  Iran: [
    'Ardabil',
    'Azarbayjan-e Gharbi',
    'Azarbayjan-e Sharqi',
    'Bushehr',
    'Chahar Mahall va Bakhtiari',
    'Esfahan',
    'Fars',
    'Gilan',
    'Golestan',
    'Hamadan',
    'Hormozgan',
    'Ilam',
    'Kerman',
    'Kermanshah',
    'Khorasan',
    'Khuzestan',
    'Kohgiluyeh va Buyer Ahmad',
    'Kordestan',
    'Lorestan',
    'Markazi',
    'Mazandaran',
    'Qazvin',
    'Qom',
    'Semnan',
    'Sistan va Baluchestan',
    'Tehran',
    'Yazd',
    'Zanjan',
  ],
  Iraq: [
    'Al Anbar',
    'Al Basrah',
    'Al Muthanna',
    'Al Qadisiyah',
    'An Najaf',
    'Arbil',
    'As Sulaymaniyah',
    "At Ta'mim",
    'Babil',
    'Baghdad',
    'Dahuk',
    'Dhi Qar',
    'Diyala',
    "Karbala'",
    'Maysan',
    'Ninawa',
    'Salah ad Din',
    'Wasit',
  ],
  Ireland: [
    'Carlow',
    'Cavan',
    'Clare',
    'Cork',
    'Donegal',
    'Dublin',
    'Galway',
    'Kerry',
    'Kildare',
    'Kilkenny',
    'Laois',
    'Leitrim',
    'Limerick',
    'Longford',
    'Louth',
    'Mayo',
    'Meath',
    'Monaghan',
    'Offaly',
    'Roscommon',
    'Sligo',
    'Tipperary',
    'Waterford',
    'Westmeath',
    'Wexford',
    'Wicklow',
  ],
  Israel: [
    'Central',
    'Haifa',
    'Jerusalem',
    'Northern',
    'Southern',
    'Tel Aviv',
  ],
  Italy: [
    'Abruzzo',
    'Basilicata',
    'Calabria',
    'Campania',
    'Emilia-Romagna',
    'Friuli-Venezia Giulia',
    'Lazio',
    'Liguria',
    'Lombardia',
    'Marche',
    'Molise',
    'Piemonte',
    'Puglia',
    'Sardegna',
    'Sicilia',
    'Toscana',
    'Trentino-Alto Adige',
    'Umbria',
    "Valle d'Aosta",
    'Veneto',
  ],
  Jamaica: [
    'Clarendon',
    'Hanover',
    'Kingston',
    'Manchester',
    'Portland',
    'Saint Andrew',
    'Saint Ann',
    'Saint Catherine',
    'Saint Elizabeth',
    'Saint James',
    'Saint Mary',
    'Saint Thomas',
    'Trelawny',
    'Westmoreland',
  ],
  Japan: [
    'Aichi',
    'Akita',
    'Aomori',
    'Chiba',
    'Ehime',
    'Fukui',
    'Fukuoka',
    'Fukushima',
    'Gifu',
    'Gumma',
    'Hiroshima',
    'Hokkaido',
    'Hyogo',
    'Ibaraki',
    'Ishikawa',
    'Iwate',
    'Kagawa',
    'Kagoshima',
    'Kanagawa',
    'Kochi',
    'Kumamoto',
    'Kyoto',
    'Mie',
    'Miyagi',
    'Miyazaki',
    'Nagano',
    'Nagasaki',
    'Nara',
    'Niigata',
    'Oita',
    'Okayama',
    'Okinawa',
    'Osaka',
    'Saga',
    'Saitama',
    'Shiga',
    'Shimane',
    'Shizuoka',
    'Tochigi',
    'Tokushima',
    'Tokyo',
    'Tottori',
    'Toyama',
    'Wakayama',
    'Yamagata',
    'Yamaguchi',
    'Yamanashi',
  ],
  Jersey: ['Jersey'],
  Jordan: [
    "'Amman",
    'Ajlun',
    "Al 'Aqabah",
    "Al Balqa'",
    'Al Karak',
    'Al Mafraq',
    'At Tafilah',
    "Az Zarqa'",
    'Irbid',
    'Jarash',
    "Ma'an",
    'Madaba',
  ],
  Kazakhstan: [
    'Almaty',
    'Aqmola',
    'Aqtobe',
    'Astana',
    'Atyrau',
    'Batys Qazaqstan',
    'Bayqongyr',
    'Mangghystau',
    'Ongtustik Qazaqstan',
    'Pavlodar',
    'Qaraghandy',
    'Qostanay',
    'Qyzylorda',
    'Shyghys Qazaqstan',
    'Soltustik Qazaqstan',
    'Zhambyl',
  ],
  Kenya: [
    'Central',
    'Coast',
    'Eastern',
    'Nairobi Area',
    'North Eastern',
    'Nyanza',
    'Rift Valley',
    'Western',
  ],
  Kiribati: [
    'Abaiang',
    'Abemama',
    'Aranuka',
    'Arorae',
    'Banaba',
    'Beru',
    'Butaritari',
    'Central Gilberts',
    'Gilbert Islands',
    'Kanton',
    'Kiritimati',
    'Kuria',
    'Line Islands',
    'Line Islands',
    'Maiana',
    'Makin',
    'Marakei',
    'Nikunau',
    'Nonouti',
    'Northern Gilberts',
    'Onotoa',
    'Phoenix Islands',
    'Southern Gilberts',
    'Tabiteuea',
    'Tabuaeran',
    'Tamana',
    'Tarawa',
    'Tarawa',
    'Teraina',
  ],
  'North Korea': [
    'Chagang-do (Chagang Province)',
    'Hamgyong-bukto (North Hamgyong Province)',
    'Hamgyong-namdo (South Hamgyong Province)',
    'Hwanghae-bukto (North Hwanghae Province)',
    'Hwanghae-namdo (South Hwanghae Province)',
    'Kaesong-si (Kaesong City)',
    'Kangwon-do (Kangwon Province)',
    "Namp'o-si (Namp'o City)",
    "P'yongan-bukto (North P'yongan Province)",
    "P'yongan-namdo (South P'yongan Province)",
    "P'yongyang-si (P'yongyang City)",
    'Yanggang-do (Yanggang Province)',
  ],
  'South Korea': [
    "Ch'ungch'ong-bukto",
    "Ch'ungch'ong-namdo",
    'Cheju-do',
    'Cholla-bukto',
    'Cholla-namdo',
    "Inch'on-gwangyoksi",
    'Kangwon-do',
    'Kwangju-gwangyoksi',
    'Kyonggi-do',
    'Kyongsang-bukto',
    'Kyongsang-namdo',
    'Pusan-gwangyoksi',
    "Soul-t'ukpyolsi",
    'Taegu-gwangyoksi',
    'Taejon-gwangyoksi',
    'Ulsan-gwangyoksi',
  ],
  Kuwait: ["Al 'Asimah", 'Al Ahmadi', 'Al Farwaniyah', "Al Jahra'", 'Hawalli'],
  Kyrgyzstan: [
    'Batken Oblasty',
    'Bishkek Shaary',
    'Chuy Oblasty (Bishkek)',
    'Jalal-Abad Oblasty',
    'Naryn Oblasty',
    'Osh Oblasty',
    'Talas Oblasty',
    'Ysyk-Kol Oblasty (Karakol)',
  ],
  Laos: [
    'Attapu',
    'Bokeo',
    'Bolikhamxai',
    'Champasak',
    'Houaphan',
    'Khammouan',
    'Louangnamtha',
    'Louangphabang',
    'Oudomxai',
    'Phongsali',
    'Salavan',
    'Savannakhet',
    'Viangchan',
    'Viangchan',
    'Xaignabouli',
    'Xaisomboun',
    'Xekong',
    'Xiangkhoang',
  ],
  Latvia: [
    'Aizkraukles Rajons',
    'Aluksnes Rajons',
    'Balvu Rajons',
    'Bauskas Rajons',
    'Cesu Rajons',
    'Daugavpils',
    'Daugavpils Rajons',
    'Dobeles Rajons',
    'Gulbenes Rajons',
    'Jekabpils Rajons',
    'Jelgava',
    'Jelgavas Rajons',
    'Jurmala',
    'Kraslavas Rajons',
    'Kuldigas Rajons',
    'Leipaja',
    'Liepajas Rajons',
    'Limbazu Rajons',
    'Ludzas Rajons',
    'Madonas Rajons',
    'Ogres Rajons',
    'Preilu Rajons',
    'Rezekne',
    'Rezeknes Rajons',
    'Riga',
    'Rigas Rajons',
    'Saldus Rajons',
    'Talsu Rajons',
    'Tukuma Rajons',
    'Valkas Rajons',
    'Valmieras Rajons',
    'Ventspils',
    'Ventspils Rajons',
  ],
  Lebanon: ['Beyrouth', 'Ech Chimal', 'Ej Jnoub', 'El Bekaa', 'Jabal Loubnane'],
  Lesotho: [
    'Berea',
    'Butha-Buthe',
    'Leribe',
    'Mafeteng',
    'Maseru',
    'Mohales Hoek',
    'Mokhotlong',
    "Qacha's Nek",
    'Quthing',
    'Thaba-Tseka',
  ],
  Liberia: [
    'Bomi',
    'Bong',
    'Grand Bassa',
    'Grand Cape Mount',
    'Grand Gedeh',
    'Grand Kru',
    'Lofa',
    'Margibi',
    'Maryland',
    'Montserrado',
    'Nimba',
    'River Cess',
    'Sinoe',
  ],
  Libya: [
    'Ajdabiya',
    "Al 'Aziziyah",
    'Al Fatih',
    'Al Jabal al Akhdar',
    'Al Jufrah',
    'Al Khums',
    'Al Kufrah',
    'An Nuqat al Khams',
    "Ash Shati'",
    'Awbari',
    'Az Zawiyah',
    'Banghazi',
    'Darnah',
    'Ghadamis',
    'Gharyan',
    'Misratah',
    'Murzuq',
    'Sabha',
    'Sawfajjin',
    'Surt',
    'Tarabulus',
    'Tarhunah',
    'Tubruq',
    'Yafran',
    'Zlitan',
  ],
  Liechtenstein: [
    'Balzers',
    'Eschen',
    'Gamprin',
    'Mauren',
    'Planken',
    'Ruggell',
    'Schaan',
    'Schellenberg',
    'Triesen',
    'Triesenberg',
    'Vaduz',
  ],
  Lithuania: [
    'Akmenes Rajonas',
    'Alytaus Rajonas',
    'Alytus',
    'Anyksciu Rajonas',
    'Birstonas',
    'Birzu Rajonas',
    'Druskininkai',
    'Ignalinos Rajonas',
    'Jonavos Rajonas',
    'Joniskio Rajonas',
    'Jurbarko Rajonas',
    'Kaisiadoriu Rajonas',
    'Kaunas',
    'Kauno Rajonas',
    'Kedainiu Rajonas',
    'Kelmes Rajonas',
    'Klaipeda',
    'Klaipedos Rajonas',
    'Kretingos Rajonas',
    'Kupiskio Rajonas',
    'Lazdiju Rajonas',
    'Marijampole',
    'Marijampoles Rajonas',
    'Mazeikiu Rajonas',
    'Moletu Rajonas',
    'Neringa Pakruojo Rajonas',
    'Palanga',
    'Panevezio Rajonas',
    'Panevezys',
    'Pasvalio Rajonas',
    'Plunges Rajonas',
    'Prienu Rajonas',
    'Radviliskio Rajonas',
    'Raseiniu Rajonas',
    'Rokiskio Rajonas',
    'Sakiu Rajonas',
    'Salcininku Rajonas',
    'Siauliai',
    'Siauliu Rajonas',
    'Silales Rajonas',
    'Silutes Rajonas',
    'Sirvintu Rajonas',
    'Skuodo Rajonas',
    'Svencioniu Rajonas',
    'Taurages Rajonas',
    'Telsiu Rajonas',
    'Traku Rajonas',
    'Ukmerges Rajonas',
    'Utenos Rajonas',
    'Varenos Rajonas',
    'Vilkaviskio Rajonas',
    'Vilniaus Rajonas',
    'Vilnius',
    'Zarasu Rajonas',
  ],
  Luxembourg: ['Diekirch', 'Grevenmacher', 'Luxembourg'],
  Macau: ['Macau'],
  'Republic of Macedonia': [
    'Aracinovo',
    'Bac',
    'Belcista',
    'Berovo',
    'Bistrica',
    'Bitola',
    'Blatec',
    'Bogdanci',
    'Bogomila',
    'Bogovinje',
    'Bosilovo',
    'Brvenica',
    'Cair (Skopje)',
    'Capari',
    'Caska',
    'Cegrane',
    'Centar (Skopje)',
    'Centar Zupa',
    'Cesinovo',
    'Cucer-Sandevo',
    'Debar',
    'Delcevo',
    'Delogozdi',
    'Demir Hisar',
    'Demir Kapija',
    'Dobrusevo',
    'Dolna Banjica',
    'Dolneni',
    'Dorce Petrov (Skopje)',
    'Drugovo',
    'Dzepciste',
    'Gazi Baba (Skopje)',
    'Gevgelija',
    'Gostivar',
    'Gradsko',
    'Ilinden',
    'Izvor',
    'Jegunovce',
    'Kamenjane',
    'Karbinci',
    'Karpos (Skopje)',
    'Kavadarci',
    'Kicevo',
    'Kisela Voda (Skopje)',
    'Klecevce',
    'Kocani',
    'Konce',
    'Kondovo',
    'Konopiste',
    'Kosel',
    'Kratovo',
    'Kriva Palanka',
    'Krivogastani',
    'Krusevo',
    'Kuklis',
    'Kukurecani',
    'Kumanovo',
    'Labunista',
    'Lipkovo',
    'Lozovo',
    'Lukovo',
    'Makedonska Kamenica',
    'Makedonski Brod',
    'Mavrovi Anovi',
    'Meseista',
    'Miravci',
    'Mogila',
    'Murtino',
    'Negotino',
    'Negotino-Poloska',
    'Novaci',
    'Novo Selo',
    'Oblesevo',
    'Ohrid',
    'Orasac',
    'Orizari',
    'Oslomej',
    'Pehcevo',
    'Petrovec',
    'Plasnia',
    'Podares',
    'Prilep',
    'Probistip',
    'Radovis',
    'Rankovce',
    'Resen',
    'Rosoman',
    'Rostusa',
    'Samokov',
    'Saraj',
    'Sipkovica',
    'Sopiste',
    'Sopotnika',
    'Srbinovo',
    'Star Dojran',
    'Staravina',
    'Staro Nagoricane',
    'Stip',
    'Struga',
    'Strumica',
    'Studenicani',
    'Suto Orizari (Skopje)',
    'Sveti Nikole',
    'Tearce',
    'Tetovo',
    'Topolcani',
    'Valandovo',
    'Vasilevo',
    'Veles',
    'Velesta',
    'Vevcani',
    'Vinica',
    'Vitoliste',
    'Vranestica',
    'Vrapciste',
    'Vratnica',
    'Vrutok',
    'Zajas',
    'Zelenikovo',
    'Zileno',
    'Zitose',
    'Zletovo',
    'Zrnovci',
  ],
  Madagascar: [
    'Antananarivo',
    'Antsiranana',
    'Fianarantsoa',
    'Mahajanga',
    'Toamasina',
    'Toliara',
  ],
  Malawi: [
    'Balaka',
    'Blantyre',
    'Chikwawa',
    'Chiradzulu',
    'Chitipa',
    'Dedza',
    'Dowa',
    'Karonga',
    'Kasungu',
    'Likoma',
    'Lilongwe',
    'Machinga (Kasupe)',
    'Mangochi',
    'Mchinji',
    'Mulanje',
    'Mwanza',
    'Mzimba',
    'Nkhata Bay',
    'Nkhotakota',
    'Nsanje',
    'Ntcheu',
    'Ntchisi',
    'Phalombe',
    'Rumphi',
    'Salima',
    'Thyolo',
    'Zomba',
  ],
  Malaysia: [
    'Johor',
    'Kedah',
    'Kelantan',
    'Labuan',
    'Melaka',
    'Negeri Sembilan',
    'Pahang',
    'Perak',
    'Perlis',
    'Pulau Pinang',
    'Sabah',
    'Sarawak',
    'Selangor',
    'Terengganu',
    'Wilayah Persekutuan',
  ],
  Maldives: [
    'Alifu',
    'Baa',
    'Dhaalu',
    'Faafu',
    'Gaafu Alifu',
    'Gaafu Dhaalu',
    'Gnaviyani',
    'Haa Alifu',
    'Haa Dhaalu',
    'Kaafu',
    'Laamu',
    'Lhaviyani',
    'Maale',
    'Meemu',
    'Noonu',
    'Raa',
    'Seenu',
    'Shaviyani',
    'Thaa',
    'Vaavu',
  ],
  Mali: [
    'Gao',
    'Kayes',
    'Kidal',
    'Koulikoro',
    'Mopti',
    'Segou',
    'Sikasso',
    'Tombouctou',
  ],
  Malta: ['Valletta'],
  'Isle of Man': ['Man,Isle of'],
  'Marshall Islands': [
    'Ailinginae',
    'Ailinglaplap',
    'Ailuk',
    'Arno',
    'Aur',
    'Bikar',
    'Bikini',
    'Bokak',
    'Ebon',
    'Enewetak',
    'Erikub',
    'Jabat',
    'Jaluit',
    'Jemo',
    'Kili',
    'Kwajalein',
    'Lae',
    'Lib',
    'Likiep',
    'Majuro',
    'Maloelap',
    'Mejit',
    'Mili',
    'Namorik',
    'Namu',
    'Rongelap',
    'Rongrik',
    'Toke',
    'Ujae',
    'Ujelang',
    'Utirik',
    'Wotho',
    'Wotje',
  ],
  Martinique: ['Martinique'],
  Mauritania: [
    'Adrar',
    'Assaba',
    'Brakna',
    'Dakhlet Nouadhibou',
    'Gorgol',
    'Guidimaka',
    'Hodh Ech Chargui',
    'Hodh El Gharbi',
    'Inchiri',
    'Nouakchott',
    'Tagant',
    'Tiris Zemmour',
    'Trarza',
  ],
  Mauritius: [
    'Agalega Islands',
    'Black River',
    'Cargados Carajos Shoals',
    'Flacq',
    'Grand Port',
    'Moka',
    'Pamplemousses',
    'Plaines Wilhems',
    'Port Louis',
    'Riviere du Rempart',
    'Rodrigues',
    'Savanne',
  ],
  Mayotte: ['Mayotte'],
  Mexico: [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Campeche',
    'Chiapas',
    'Chihuahua',
    'Coahuila de Zaragoza',
    'Colima',
    'Distrito Federal',
    'Durango',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'Mexico',
    'Michoacan de Ocampo',
    'Morelos',
    'Nayarit',
    'Nuevo Leon',
    'Oaxaca',
    'Puebla',
    'Queretaro de Arteaga',
    'Quintana Roo',
    'San Luis Potosi',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz-Llave',
    'Yucatan',
    'Zacatecas',
  ],
  'Federated States of Micronesia': [
    'Chuuk (Truk)',
    'Kosrae',
    'Pohnpei',
    'Yap',
  ],
  Moldova: [
    'Balti',
    'Cahul',
    'Chisinau',
    'Chisinau',
    'Dubasari',
    'Edinet',
    'Gagauzia',
    'Lapusna',
    'Orhei',
    'Soroca',
    'Tighina',
    'Ungheni',
  ],
  Monaco: ['Fontvieille', 'La Condamine', 'Monaco-Ville', 'Monte-Carlo'],
  Mongolia: [
    'Arhangay',
    'Bayan-Olgiy',
    'Bayanhongor',
    'Bulgan',
    'Darhan',
    'Dornod',
    'Dornogovi',
    'Dundgovi',
    'Dzavhan',
    'Erdenet',
    'Govi-Altay',
    'Hentiy',
    'Hovd',
    'Hovsgol',
    'Omnogovi',
    'Ovorhangay',
    'Selenge',
    'Suhbaatar',
    'Tov',
    'Ulaanbaatar',
    'Uvs',
  ],
  Montserrat: ['Saint Anthony', 'Saint Georges', "Saint Peter's"],
  Morocco: [
    'Agadir',
    'Al Hoceima',
    'Azilal',
    'Ben Slimane',
    'Beni Mellal',
    'Boulemane',
    'Casablanca',
    'Chaouen',
    'El Jadida',
    'El Kelaa des Srarhna',
    'Er Rachidia',
    'Essaouira',
    'Fes',
    'Figuig',
    'Guelmim',
    'Ifrane',
    'Kenitra',
    'Khemisset',
    'Khenifra',
    'Khouribga',
    'Laayoune',
    'Larache',
    'Marrakech',
    'Meknes',
    'Nador',
    'Ouarzazate',
    'Oujda',
    'Rabat-Sale',
    'Safi',
    'Settat',
    'Sidi Kacem',
    'Tan-Tan',
    'Tanger',
    'Taounate',
    'Taroudannt',
    'Tata',
    'Taza',
    'Tetouan',
    'Tiznit',
  ],
  Mozambique: [
    'Cabo Delgado',
    'Gaza',
    'Inhambane',
    'Manica',
    'Maputo',
    'Nampula',
    'Niassa',
    'Sofala',
    'Tete',
    'Zambezia',
  ],
  Namibia: [
    'Caprivi',
    'Erongo',
    'Hardap',
    'Karas',
    'Khomas',
    'Kunene',
    'Ohangwena',
    'Okavango',
    'Omaheke',
    'Omusati',
    'Oshana',
    'Oshikoto',
    'Otjozondjupa',
  ],
  Nauru: [
    'Aiwo',
    'Anabar',
    'Anetan',
    'Anibare',
    'Baiti',
    'Boe',
    'Buada',
    'Denigomodu',
    'Ewa',
    'Ijuw',
    'Meneng',
    'Nibok',
    'Uaboe',
    'Yaren',
  ],
  Nepal: [
    'Bagmati',
    'Bheri',
    'Dhawalagiri',
    'Gandaki',
    'Janakpur',
    'Karnali',
    'Kosi',
    'Lumbini',
    'Mahakali',
    'Mechi',
    'Narayani',
    'Rapti',
    'Sagarmatha',
    'Seti',
  ],
  Netherlands: [
    'Drenthe',
    'Flevoland',
    'Friesland',
    'Gelderland',
    'Groningen',
    'Limburg',
    'Noord-Brabant',
    'Noord-Holland',
    'Overijssel',
    'Utrecht',
    'Zeeland',
    'Zuid-Holland',
  ],
  'New Caledonia': ['Iles Loyaute', 'Nord', 'Sud'],
  'New Zealand': [
    'Auckland',
    'Akaroa',
    'Amuri',
    'Ashburton',
    'Bay of Islands',
    'Bay of Plenty',
    'Bruce',
    'Buller',
    'Canterbury',
    'Chatham Islands',
    'Cheviot',
    'Clifton',
    'Clutha',
    'Cook',
    'Dannevirke',
    'Egmont',
    'Eketahuna',
    'Ellesmere',
    'Eltham',
    'Eyre',
    'Featherston',
    'Franklin',
    'Gisborne',
    'Golden Bay',
    'Great Barrier Island',
    'Grey',
    'Hauraki Plains',
    'Hawera',
    "Hawke's Bay",
    'Heathcote',
    'Hikurangi',
    'Hobson',
    'Hokianga',
    'Horowhenua',
    'Hurunui',
    'Hutt',
    'Inangahua',
    'Inglewood',
    'Kaikoura',
    'Kairanga',
    'Kiwitea',
    'Lake',
    'Mackenzie',
    'Malvern',
    'Manaia',
    'Manawatu-Wanganui',
    'Mangonui',
    'Maniototo',
    'Marlborough',
    'Masterton',
    'Matamata',
    'Mount Herbert',
    'Nelson',
    'Northland',
    'Ohinemuri',
    'Opotiki',
    'Oroua',
    'Otago',
    'Otamatea',
    'Otorohanga',
    'Oxford',
    'Pahiatua',
    'Paparua',
    'Patea',
    'Piako',
    'Pohangina',
    'Raglan',
    'Rangiora',
    'Rangitikei',
    'Rodney',
    'Rotorua',
    'Runanga',
    'Saint Kilda',
    'Silverpeaks',
    'Southland',
    'Stewart Island',
    'Stratford',
    'Strathallan',
    'Taranaki',
    'Tasman',
    'Taumarunui',
    'Taupo',
    'Tauranga',
    'Thames-Coromandel',
    'Tuapeka',
    'Vincent',
    'Waiapu',
    'Waiheke',
    'Waihemo',
    'Waikato',
    'Waikohu',
    'Waimairi',
    'Waimarino',
    'Waimate',
    'Waimate West',
    'Waimea',
    'Waipa',
    'Waipawa',
    'Waipukurau',
    'Wairarapa South',
    'Wairewa',
    'Wairoa',
    'Waitaki',
    'Waitomo',
    'Waitotara',
    'Wallace',
    'Wanganui',
    'Waverley',
    'Wellington',
    'West Coast',
    'Westland',
    'Whakatane',
    'Whangarei',
    'Whangaroa',
    'Woodville',
  ],
  Nicaragua: [
    'Atlantico Norte',
    'Atlantico Sur',
    'Boaco',
    'Carazo',
    'Chinandega',
    'Chontales',
    'Esteli',
    'Granada',
    'Jinotega',
    'Leon',
    'Madriz',
    'Managua',
    'Masaya',
    'Matagalpa',
    'Nueva Segovia',
    'Rio San Juan',
    'Rivas',
  ],
  Niger: [
    'Agadez',
    'Diffa',
    'Dosso',
    'Maradi',
    'Niamey',
    'Tahoua',
    'Tillaberi',
    'Zinder',
  ],
  Nigeria: [
    'Abia',
    'Abuja Federal Capital Territory',
    'Adamawa',
    'Akwa Ibom',
    'Anambra',
    'Bauchi',
    'Bayelsa',
    'Benue',
    'Borno',
    'Cross River',
    'Delta',
    'Ebonyi',
    'Edo',
    'Ekiti',
    'Enugu',
    'Gombe',
    'Imo',
    'Jigawa',
    'Kaduna',
    'Kano',
    'Katsina',
    'Kebbi',
    'Kogi',
    'Kwara',
    'Lagos',
    'Nassarawa',
    'Niger',
    'Ogun',
    'Ondo',
    'Osun',
    'Oyo',
    'Plateau',
    'Rivers',
    'Sokoto',
    'Taraba',
    'Yobe',
    'Zamfara',
  ],
  Niue: ['Niue'],
  'Norfolk Island': ['Norfolk Island'],
  'Northern Mariana Islands': ['Northern Islands', 'Rota', 'Saipan', 'Tinian'],
  Norway: [
    'Akershus',
    'Aust-Agder',
    'Buskerud',
    'Finnmark',
    'Hedmark',
    'Hordaland',
    'More og Romsdal',
    'Nord-Trondelag',
    'Nordland',
    'Oppland',
    'Oslo',
    'Ostfold',
    'Rogaland',
    'Sogn og Fjordane',
    'Sor-Trondelag',
    'Telemark',
    'Troms',
    'Vest-Agder',
    'Vestfold',
  ],
  Oman: [
    'Ad Dakhiliyah',
    'Al Batinah',
    'Al Wusta',
    'Ash Sharqiyah',
    'Az Zahirah',
    'Masqat',
    'Musandam',
    'Zufar',
  ],
  Pakistan: [
    'Balochistan',
    'Federally Administered Tribal Areas',
    'Islamabad Capital Territory',
    'Khyber Pakhtunkhwa',
    'Punjab',
    'Sindh',
  ],
  Palau: [
    'Aimeliik',
    'Airai',
    'Angaur',
    'Hatobohei',
    'Kayangel',
    'Koror',
    'Melekeok',
    'Ngaraard',
    'Ngarchelong',
    'Ngardmau',
    'Ngatpang',
    'Ngchesar',
    'Ngeremlengui',
    'Ngiwal',
    'Palau Island',
    'Peleliu',
    'Sonsoral',
    'Tobi',
  ],
  Panama: [
    'Bocas del Toro',
    'Chiriqui',
    'Cocle',
    'Colon',
    'Darien',
    'Herrera',
    'Los Santos',
    'Panama',
    'San Blas',
    'Veraguas',
  ],
  'Papua New Guinea': [
    'Bougainville',
    'Central',
    'Chimbu',
    'East New Britain',
    'East Sepik',
    'Eastern Highlands',
    'Enga',
    'Gulf',
    'Madang',
    'Manus',
    'Milne Bay',
    'Morobe',
    'National Capital',
    'New Ireland',
    'Northern',
    'Sandaun',
    'Southern Highlands',
    'West New Britain',
    'Western',
    'Western Highlands',
  ],
  Paraguay: [
    'Alto Paraguay',
    'Alto Parana',
    'Amambay',
    'Asuncion (city)',
    'Boqueron',
    'Caaguazu',
    'Caazapa',
    'Canindeyu',
    'Central',
    'Concepcion',
    'Cordillera',
    'Guaira',
    'Itapua',
    'Misiones',
    'Neembucu',
    'Paraguari',
    'Presidente Hayes',
    'San Pedro',
  ],
  Peru: [
    'Amazonas',
    'Ancash',
    'Apurimac',
    'Arequipa',
    'Ayacucho',
    'Cajamarca',
    'Callao',
    'Cusco',
    'Huancavelica',
    'Huanuco',
    'Ica',
    'Junin',
    'La Libertad',
    'Lambayeque',
    'Lima',
    'Loreto',
    'Madre de Dios',
    'Moquegua',
    'Pasco',
    'Piura',
    'Puno',
    'San Martin',
    'Tacna',
    'Tumbes',
    'Ucayali',
  ],
  Philippines: [
    'Abra',
    'Agusan del Norte',
    'Agusan del Sur',
    'Aklan',
    'Albay',
    'Angeles',
    'Antique',
    'Aurora',
    'Bacolod',
    'Bago',
    'Baguio',
    'Bais',
    'Basilan',
    'Basilan City',
    'Bataan',
    'Batanes',
    'Batangas',
    'Batangas City',
    'Benguet',
    'Bohol',
    'Bukidnon',
    'Bulacan',
    'Butuan',
    'Cabanatuan',
    'Cadiz',
    'Cagayan',
    'Cagayan de Oro',
    'Calbayog',
    'Caloocan',
    'Camarines Norte',
    'Camarines Sur',
    'Camiguin',
    'Canlaon',
    'Capiz',
    'Catanduanes',
    'Cavite',
    'Cavite City',
    'Cebu',
    'Cebu City',
    'Cotabato',
    'Dagupan',
    'Danao',
    'Dapitan',
    'Davao City Davao',
    'Davao del Sur',
    'Davao Oriental',
    'Dipolog',
    'Dumaguete',
    'Eastern Samar',
    'General Santos',
    'Gingoog',
    'Ifugao',
    'Iligan',
    'Ilocos Norte',
    'Ilocos Sur',
    'Iloilo',
    'Iloilo City',
    'Iriga',
    'Isabela',
    'Kalinga-Apayao',
    'La Carlota',
    'La Union',
    'Laguna',
    'Lanao del Norte',
    'Lanao del Sur',
    'Laoag',
    'Lapu-Lapu',
    'Legaspi',
    'Leyte',
    'Lipa',
    'Lucena',
    'Maguindanao',
    'Mandaue',
    'Manila',
    'Marawi',
    'Marinduque',
    'Masbate',
    'Mindoro Occidental',
    'Mindoro Oriental',
    'Misamis Occidental',
    'Misamis Oriental',
    'Mountain',
    'Naga',
    'Negros Occidental',
    'Negros Oriental',
    'North Cotabato',
    'Northern Samar',
    'Nueva Ecija',
    'Nueva Vizcaya',
    'Olongapo',
    'Ormoc',
    'Oroquieta',
    'Ozamis',
    'Pagadian',
    'Palawan',
    'Palayan',
    'Pampanga',
    'Pangasinan',
    'Pasay',
    'Puerto Princesa',
    'Quezon',
    'Quezon City',
    'Quirino',
    'Rizal',
    'Romblon',
    'Roxas',
    'Samar',
    'San Carlos (in Negros Occidental)',
    'San Carlos (in Pangasinan)',
    'San Jose',
    'San Pablo',
    'Silay',
    'Siquijor',
    'Sorsogon',
    'South Cotabato',
    'Southern Leyte',
    'Sultan Kudarat',
    'Sulu',
    'Surigao',
    'Surigao del Norte',
    'Surigao del Sur',
    'Tacloban',
    'Tagaytay',
    'Tagbilaran',
    'Tangub',
    'Tarlac',
    'Tawitawi',
    'Toledo',
    'Trece Martires',
    'Zambales',
    'Zamboanga',
    'Zamboanga del Norte',
    'Zamboanga del Sur',
  ],
  'Pitcairn Islands': ['Pitcaim Islands'],
  Poland: [
    'Dolnoslaskie',
    'Kujawsko-Pomorskie',
    'Lodzkie',
    'Lubelskie',
    'Lubuskie',
    'Malopolskie',
    'Mazowieckie',
    'Opolskie',
    'Podkarpackie',
    'Podlaskie',
    'Pomorskie',
    'Slaskie',
    'Swietokrzyskie',
    'Warminsko-Mazurskie',
    'Wielkopolskie',
    'Zachodniopomorskie',
  ],
  Portugal: [
    'Acores (Azores)',
    'Aveiro',
    'Beja',
    'Braga',
    'Braganca',
    'Castelo Branco',
    'Coimbra',
    'Evora',
    'Faro',
    'Guarda',
    'Leiria',
    'Lisboa',
    'Madeira',
    'Portalegre',
    'Porto',
    'Santarem',
    'Setubal',
    'Viana do Castelo',
    'Vila Real',
    'Viseu',
  ],
  'Puerto Rico': [
    'Adjuntas',
    'Aguada',
    'Aguadilla',
    'Aguas Buenas',
    'Aibonito',
    'Anasco',
    'Arecibo',
    'Arroyo',
    'Barceloneta',
    'Barranquitas',
    'Bayamon',
    'Cabo Rojo',
    'Caguas',
    'Camuy',
    'Canovanas',
    'Carolina',
    'Catano',
    'Cayey',
    'Ceiba',
    'Ciales',
    'Cidra',
    'Coamo',
    'Comerio',
    'Corozal',
    'Culebra',
    'Dorado',
    'Fajardo',
    'Florida',
    'Guanica',
    'Guayama',
    'Guayanilla',
    'Guaynabo',
    'Gurabo',
    'Hatillo',
    'Hormigueros',
    'Humacao',
    'Isabela',
    'Jayuya',
    'Juana Diaz',
    'Juncos',
    'Lajas',
    'Lares',
    'Las Marias',
    'Las Piedras',
    'Loiza',
    'Luquillo',
    'Manati',
    'Maricao',
    'Maunabo',
    'Mayaguez',
    'Moca',
    'Morovis',
    'Naguabo',
    'Naranjito',
    'Orocovis',
    'Patillas',
    'Penuelas',
    'Ponce',
    'Quebradillas',
    'Rincon',
    'Rio Grande',
    'Sabana Grande',
    'Salinas',
    'San German',
    'San Juan',
    'San Lorenzo',
    'San Sebastian',
    'Santa Isabel',
    'Toa Alta',
    'Toa Baja',
    'Trujillo Alto',
    'Utuado',
    'Vega Alta',
    'Vega Baja',
    'Vieques',
    'Villalba',
    'Yabucoa',
    'Yauco',
  ],
  Qatar: [
    'Ad Dawhah',
    'Al Ghuwayriyah',
    'Al Jumayliyah',
    'Al Khawr',
    'Al Wakrah',
    'Ar Rayyan',
    'Jarayan al Batinah',
    'Madinat ash Shamal',
    'Umm Salal',
  ],
  Réunion: ['Reunion'],
  Romania: [
    'Alba',
    'Arad',
    'Arges',
    'Bacau',
    'Bihor',
    'Bistrita-Nasaud',
    'Botosani',
    'Braila',
    'Brasov',
    'Bucuresti',
    'Buzau',
    'Calarasi',
    'Caras-Severin',
    'Cluj',
    'Constanta',
    'Covasna',
    'Dimbovita',
    'Dolj',
    'Galati',
    'Giurgiu',
    'Gorj',
    'Harghita',
    'Hunedoara',
    'Ialomita',
    'Iasi',
    'Ilfov',
    'Maramures',
    'Mehedinti',
    'Mures',
    'Neamt',
    'Olt',
    'Prahova',
    'Salaj',
    'Satu Mare',
    'Sibiu',
    'Suceava',
    'Teleorman',
    'Timis',
    'Tulcea',
    'Vaslui',
    'Vilcea',
    'Vrancea',
  ],
  Russia: [
    'Adygeya (Maykop)',
    'Aginskiy Buryatskiy (Aginskoye)',
    'Altay (Gorno-Altaysk)',
    'Altayskiy (Barnaul)',
    'Amurskaya (Blagoveshchensk)',
    "Arkhangel'skaya",
    'Astrakhanskaya',
    'Bashkortostan (Ufa)',
    'Belgorodskaya',
    'Bryanskaya',
    'Buryatiya (Ulan-Ude)',
    'Chechnya (Groznyy)',
    'Chelyabinskaya',
    'Chitinskaya',
    "Chukotskiy (Anadyr')",
    'Chuvashiya (Cheboksary)',
    'Dagestan (Makhachkala)',
    'Evenkiyskiy (Tura)',
    "Ingushetiya (Nazran')",
    'Irkutskaya',
    'Ivanovskaya',
    "Kabardino-Balkariya (Nal'chik)",
    'Kaliningradskaya',
    'Kalmykiya (Elista)',
    'Kaluzhskaya',
    'Kamchatskaya (Petropavlovsk-Kamchatskiy)',
    'Karachayevo-Cherkesiya (Cherkessk)',
    'Kareliya (Petrozavodsk)',
    'Kemerovskaya',
    'Khabarovskiy',
    'Khakasiya (Abakan)',
    'Khanty-Mansiyskiy (Khanty-Mansiysk)',
    'Kirovskaya',
    'Komi (Syktyvkar)',
    'Komi-Permyatskiy (Kudymkar)',
    'Koryakskiy (Palana)',
    'Kostromskaya',
    'Krasnodarskiy',
    'Krasnoyarskiy',
    'Kurganskaya',
    'Kurskaya',
    'Leningradskaya',
    'Lipetskaya',
    'Magadanskaya',
    'Mariy-El (Yoshkar-Ola)',
    'Mordoviya (Saransk)',
    'Moskovskaya',
    'Moskva (Moscow)',
    'Murmanskaya',
    "Nenetskiy (Nar'yan-Mar)",
    'Nizhegorodskaya',
    'Novgorodskaya',
    'Novosibirskaya',
    'Omskaya',
    'Orenburgskaya',
    'Orlovskaya (Orel)',
    'Penzenskaya',
    'Permskaya',
    'Primorskiy (Vladivostok)',
    'Pskovskaya',
    'Rostovskaya',
    'Ryazanskaya',
    'Sakha (Yakutsk)',
    'Sakhalinskaya (Yuzhno-Sakhalinsk)',
    'Samarskaya',
    'Sankt-Peterburg (Saint Petersburg)',
    'Saratovskaya',
    'Severnaya Osetiya-Alaniya [North Ossetia] (Vladikavkaz)',
    'Smolenskaya',
    "Stavropol'skiy",
    'Sverdlovskaya (Yekaterinburg)',
    'Tambovskaya',
    "Tatarstan (Kazan')",
    'Taymyrskiy (Dudinka)',
    'Tomskaya',
    "Tul'skaya",
    'Tverskaya',
    'Tyumenskaya',
    'Tyva (Kyzyl)',
    'Udmurtiya (Izhevsk)',
    "Ul'yanovskaya",
    "Ust'-Ordynskiy Buryatskiy (Ust'-Ordynskiy)",
    'Vladimirskaya',
    'Volgogradskaya',
    'Vologodskaya',
    'Voronezhskaya',
    'Yamalo-Nenetskiy (Salekhard)',
    'Yaroslavskaya',
    'Yevreyskaya',
  ],
  Rwanda: [
    'Butare',
    'Byumba',
    'Cyangugu',
    'Gikongoro',
    'Gisenyi',
    'Gitarama',
    'Kibungo',
    'Kibuye',
    'Kigali Rurale',
    'Kigali-ville',
    'Ruhengeri',
    'Umutara',
  ],
  'Saint Helena': ['Ascension', 'Saint Helena', 'Tristan da Cunha'],
  'Saint Kitts and Nevis': [
    'Christ Church Nichola Town',
    'Saint Anne Sandy Point',
    'Saint George Basseterre',
    'Saint George Gingerland',
    'Saint James Windward',
    'Saint John Capisterre',
    'Saint John Figtree',
    'Saint Mary Cayon',
    'Saint Paul Capisterre',
    'Saint Paul Charlestown',
    'Saint Peter Basseterre',
    'Saint Thomas Lowland',
    'Saint Thomas Middle Island',
    'Trinity Palmetto Point',
  ],
  'Saint Lucia': [
    'Anse-la-Raye',
    'Castries',
    'Choiseul',
    'Dauphin',
    'Dennery',
    'Gros Islet',
    'Laborie',
    'Micoud',
    'Praslin',
    'Soufriere',
    'Vieux Fort',
  ],
  'Saint Pierre and Miquelon': ['Miquelon', 'Saint Pierre'],
  'Saint Vincent and the Grenadines': [
    'Charlotte',
    'Grenadines',
    'Saint Andrew',
    'Saint David',
    'Saint George',
    'Saint Patrick',
  ],
  Samoa: [
    "A'ana",
    'Aiga-i-le-Tai',
    'Atua',
    "Fa'asaleleaga",
    "Gaga'emauga",
    'Gagaifomauga',
    'Palauli',
    "Satupa'itea",
    'Tuamasaga',
    "Va'a-o-Fonoti",
    'Vaisigano',
  ],
  'San Marino': [
    'Acquaviva',
    'Borgo Maggiore',
    'Chiesanuova',
    'Domagnano',
    'Faetano',
    'Fiorentino',
    'Monte Giardino',
    'San Marino',
    'Serravalle',
  ],
  'São Tomé and Príncipe': ['Principe', 'Sao Tome'],
  'Saudi Arabia': [
    "'Asir",
    'Al Bahah',
    'Al Hudud ash Shamaliyah',
    'Al Jawf',
    'Al Madinah',
    'Al Qasim',
    'Ar Riyad',
    'Ash Sharqiyah (Eastern Province)',
    "Ha'il",
    'Jizan',
    'Makkah',
    'Najran',
    'Tabuk',
  ],
  Senegal: [
    'Dakar',
    'Diourbel',
    'Fatick',
    'Kaolack',
    'Kolda',
    'Louga',
    'Saint-Louis',
    'Tambacounda',
    'Thies',
    'Ziguinchor',
  ],
  Serbia: [
    'Beograd',
    'Borski okrug',
    'Braničevski okrug',
    'Jablanički okrug',
    'Južnobanatski okrug',
    'Južnobački okrug',
    'Kolubarski okrug',
    'Kosovo-Metohija',
    'Kosovski okrug',
    'Kosovsko-Mitrovački okrug',
    'Kosovsko-Pomoravski okrug',
    'Mačvanski okrug',
    'Moravički okrug',
    'Nišavski okrug',
    'Pećki okrug',
    'Pirotski okrug',
    'Podunavski okrug',
    'Pomoravski okrug',
    'Prizrenski okrug',
    'Pčinjski okrug',
    'Rasinski okrug',
    'Raški okrug',
    'Severnobanatski okrug',
    'Severnobački okrug',
    'Srednjebanatski okrug',
    'Sremski okrug',
    'Toplički okrug',
    'Vojvodina',
    'Zaječarski okrug',
    'Zapadnobački okrug',
    'Zlatiborski okrug',
    'Šumadijski okrug',
  ],
  Seychelles: [
    'Anse aux Pins',
    'Anse Boileau',
    'Anse Etoile',
    'Anse Louis',
    'Anse Royale',
    'Baie Lazare',
    'Baie Sainte Anne',
    'Beau Vallon',
    'Bel Air',
    'Bel Ombre',
    'Cascade',
    'Glacis',
    "Grand' Anse (on Mahe)",
    "Grand' Anse (on Praslin)",
    'La Digue',
    'La Riviere Anglaise',
    'Mont Buxton',
    'Mont Fleuri',
    'Plaisance',
    'Pointe La Rue',
    'Port Glaud',
    'Saint Louis',
    'Takamaka',
  ],
  'Sierra Leone': ['Eastern', 'Northern', 'Southern', 'Western'],
  Singapore: ['Singapore'],
  Slovakia: [
    'Banskobystricky',
    'Bratislavsky',
    'Kosicky',
    'Nitriansky',
    'Presovsky',
    'Trenciansky',
    'Trnavsky',
    'Zilinsky',
  ],
  Slovenia: [
    'Ajdovscina',
    'Beltinci',
    'Bled',
    'Bohinj',
    'Borovnica',
    'Bovec',
    'Brda',
    'Brezice',
    'Brezovica',
    'Cankova-Tisina',
    'Celje',
    'Cerklje na Gorenjskem',
    'Cerknica',
    'Cerkno',
    'Crensovci',
    'Crna na Koroskem',
    'Crnomelj',
    'Destrnik-Trnovska Vas',
    'Divaca',
    'Dobrepolje',
    'Dobrova-Horjul-Polhov Gradec',
    'Dol pri Ljubljani',
    'Domzale',
    'Dornava',
    'Dravograd',
    'Duplek',
    'Gorenja Vas-Poljane',
    'Gorisnica',
    'Gornja Radgona',
    'Gornji Grad',
    'Gornji Petrovci',
    'Grosuplje',
    'Hodos Salovci',
    'Hrastnik',
    'Hrpelje-Kozina',
    'Idrija',
    'Ig',
    'Ilirska Bistrica',
    'Ivancna Gorica',
    'Izola',
    'Jesenice',
    'Jursinci',
    'Kamnik',
    'Kanal',
    'Kidricevo',
    'Kobarid',
    'Kobilje',
    'Kocevje',
    'Komen',
    'Koper',
    'Kozje',
    'Kranj',
    'Kranjska Gora',
    'Krsko',
    'Kungota',
    'Kuzma',
    'Lasko',
    'Lenart',
    'Lendava',
    'Litija',
    'Ljubljana',
    'Ljubno',
    'Ljutomer',
    'Logatec',
    'Loska Dolina',
    'Loski Potok',
    'Luce',
    'Lukovica',
    'Majsperk',
    'Maribor',
    'Medvode',
    'Menges',
    'Metlika',
    'Mezica',
    'Miren-Kostanjevica',
    'Mislinja',
    'Moravce',
    'Moravske Toplice',
    'Mozirje',
    'Murska Sobota',
    'Muta',
    'Naklo',
    'Nazarje',
    'Nova Gorica',
    'Novo Mesto',
    'Odranci',
    'Ormoz',
    'Osilnica',
    'Pesnica',
    'Piran',
    'Pivka',
    'Podcetrtek',
    'Podvelka-Ribnica',
    'Postojna',
    'Preddvor',
    'Ptuj',
    'Puconci',
    'Race-Fram',
    'Radece',
    'Radenci',
    'Radlje ob Dravi',
    'Radovljica',
    'Ravne-Prevalje',
    'Ribnica',
    'Rogasevci',
    'Rogaska Slatina',
    'Rogatec',
    'Ruse',
    'Semic',
    'Sencur',
    'Sentilj',
    'Sentjernej',
    'Sentjur pri Celju',
    'Sevnica',
    'Sezana',
    'Skocjan',
    'Skofja Loka',
    'Skofljica',
    'Slovenj Gradec',
    'Slovenska Bistrica',
    'Slovenske Konjice',
    'Smarje pri Jelsah',
    'Smartno ob Paki',
    'Sostanj',
    'Starse',
    'Store',
    'Sveti Jurij',
    'Tolmin',
    'Trbovlje',
    'Trebnje',
    'Trzic',
    'Turnisce',
    'Velenje',
    'Velike Lasce',
    'Videm',
    'Vipava',
    'Vitanje',
    'Vodice',
    'Vojnik',
    'Vrhnika',
    'Vuzenica',
    'Zagorje ob Savi',
    'Zalec',
    'Zavrc',
    'Zelezniki',
    'Ziri',
    'Zrece',
  ],
  'Solomon Islands': [
    'Bellona',
    'Central',
    'Choiseul (Lauru)',
    'Guadalcanal',
    'Honiara',
    'Isabel',
    'Makira',
    'Malaita',
    'Rennell',
    'Temotu',
    'Western',
  ],
  Somalia: [
    'Awdal',
    'Bakool',
    'Banaadir',
    'Bari',
    'Bay',
    'Galguduud',
    'Gedo',
    'Hiiraan',
    'Jubbada Dhexe',
    'Jubbada Hoose',
    'Mudug',
    'Nugaal',
    'Sanaag',
    'Shabeellaha Dhexe',
    'Shabeellaha Hoose',
    'Sool',
    'Togdheer',
    'Woqooyi Galbeed',
  ],
  'South Africa': [
    'Eastern Cape',
    'Free State',
    'Gauteng',
    'KwaZulu-Natal',
    'Mpumalanga',
    'North-West',
    'Northern Cape',
    'Northern Province',
    'Western Cape',
  ],
  'South Georgia': [
    'Bird Island',
    'Bristol Island',
    'Clerke Rocks',
    'Montagu Island',
    'Saunders Island',
    'South Georgia',
    'Southern Thule',
    'Traversay Islands',
  ],
  'South Sudan': [
    'Andalucia',
    'Aragon',
    'Asturias',
    'Baleares (Balearic Islands)',
    'Canarias (Canary Islands)',
    'Cantabria',
    'Castilla y Leon',
    'Castilla-La Mancha',
    'Cataluna',
    'Ceuta',
    'Communidad Valencian',
    'Extremadura',
    'Galicia',
    'Islas Chafarinas',
    'La Rioja',
    'Madrid',
    'Melilla',
    'Murcia',
    'Navarra',
    'Pais Vasco (Basque Country)',
    'Penon de Alhucemas',
    'Penon de Velez de la Gomera',
  ],
  Spain: [
    'A Coruña',
    'Álava',
    'Albacete',
    'Alicante',
    'Almería',
    'Asturias',
    'Ávila',
    'Badajoz',
    'Balearic Islands',
    'Barcelona',
    'Biscay',
    'Burgos',
    'Cáceres',
    'Cádiz',
    'Cantabria',
    'Castellón',
    'Ciudad Real',
    'Córdoba',
    'Cuenca',
    'Gipuzkoa',
    'Girona',
    'Granada',
    'Guadalajara',
    'Huelva',
    'Huesca',
    'Jaén',
    'La Rioja',
    'Las Palmas',
    'León',
    'Lleida',
    'Lugo',
    'Madrid',
    'Málaga',
    'Murcia',
    'Navarre',
    'Ourense',
    'Palencia',
    'Pontevedra',
    'Salamanca',
    'Santa Cruz de Tenerife',
    'Segovia',
    'Seville',
    'Soria',
    'Tarragona',
    'Teruel',
    'Toledo',
    ' Valencia',
    'Valladolid',
    'Zamora',
    'Zaragoza',
  ],
  'Sri Lanka': [
    'Central',
    'Eastern',
    'North Central',
    'North Eastern',
    'North Western',
    'Northern',
    'Sabaragamuwa',
    'Southern',
    'Uva',
    'Western',
  ],
  Sudan: [
    "A'ali an Nil",
    'Al Bahr al Ahmar',
    'Al Buhayrat',
    'Al Jazirah',
    'Al Khartum',
    'Al Qadarif',
    'Al Wahdah',
    'An Nil al Abyad',
    'An Nil al Azraq',
    'Ash Shamaliyah',
    'Bahr al Jabal',
    "Gharb al Istiwa'iyah",
    'Gharb Bahr al Ghazal',
    'Gharb Darfur',
    'Gharb Kurdufan',
    'Janub Darfur',
    'Janub Kurdufan',
    'Junqali',
    'Kassala',
    'Nahr an Nil',
    'Shamal Bahr al Ghazal',
    'Shamal Darfur',
    'Shamal Kurdufan',
    "Sharq al Istiwa'iyah",
    'Sinnar',
    'Warab',
  ],
  Suriname: [
    'Brokopondo',
    'Commewijne',
    'Coronie',
    'Marowijne',
    'Nickerie',
    'Para',
    'Paramaribo',
    'Saramacca',
    'Sipaliwini',
    'Wanica',
  ],
  'Svalbard and Jan Mayen': [
    'Barentsoya',
    'Bjornoya',
    'Edgeoya',
    'Hopen',
    'Kvitoya',
    'Nordaustandet',
    'Prins Karls Forland',
    'Spitsbergen',
  ],
  Swaziland: ['Hhohho', 'Lubombo', 'Manzini', 'Shiselweni'],
  Sweden: [
    'Blekinge',
    'Dalarnas',
    'Gavleborgs',
    'Gotlands',
    'Hallands',
    'Jamtlands',
    'Jonkopings',
    'Kalmar',
    'Kronobergs',
    'Norrbottens',
    'Orebro',
    'Ostergotlands',
    'Skane',
    'Sodermanlands',
    'Stockholms',
    'Uppsala',
    'Varmlands',
    'Vasterbottens',
    'Vasternorrlands',
    'Vastmanlands',
    'Vastra Gotalands',
  ],
  Switzerland: [
    'Aargau',
    'Ausser-Rhoden',
    'Basel-Landschaft',
    'Basel-Stadt',
    'Bern',
    'Fribourg',
    'Geneve',
    'Glarus',
    'Graubunden',
    'Inner-Rhoden',
    'Jura',
    'Luzern',
    'Neuchatel',
    'Nidwalden',
    'Obwalden',
    'Sankt Gallen',
    'Schaffhausen',
    'Schwyz',
    'Solothurn',
    'Thurgau',
    'Ticino',
    'Uri',
    'Valais',
    'Vaud',
    'Zug',
    'Zurich',
  ],
  Syria: [
    'Al Hasakah',
    'Al Ladhiqiyah',
    'Al Qunaytirah',
    'Ar Raqqah',
    "As Suwayda'",
    "Dar'a",
    'Dayr az Zawr',
    'Dimashq',
    'Halab',
    'Hamah',
    'Hims',
    'Idlib',
    'Rif Dimashq',
    'Tartus',
  ],
  Taiwan: [
    'Chang-hua',
    'Chi-lung',
    'Chia-i',
    'Chia-i',
    "Chung-hsing-hsin-ts'un",
    'Hsin-chu',
    'Hsin-chu',
    'Hua-lien',
    'I-lan',
    'Kao-hsiung',
    'Kao-hsiung',
    'Miao-li',
    "Nan-t'ou",
    "P'eng-hu",
    "P'ing-tung",
    "T'ai-chung",
    "T'ai-chung",
    "T'ai-nan",
    "T'ai-nan",
    "T'ai-pei",
    "T'ai-pei",
    "T'ai-tung",
    "T'ao-yuan",
    'Yun-lin',
  ],
  Tajikistan: [
    'Viloyati Khatlon',
    'Viloyati Leninobod',
    'Viloyati Mukhtori Kuhistoni Badakhshon',
  ],
  Tanzania: [
    'Arusha',
    'Dar es Salaam',
    'Dodoma',
    'Iringa',
    'Kagera',
    'Kigoma',
    'Kilimanjaro',
    'Lindi',
    'Mara',
    'Mbeya',
    'Morogoro',
    'Mtwara',
    'Mwanza',
    'Pemba North',
    'Pemba South',
    'Pwani',
    'Rukwa',
    'Ruvuma',
    'Shinyanga',
    'Singida',
    'Tabora',
    'Tanga',
    'Zanzibar Central/South',
    'Zanzibar North',
    'Zanzibar Urban/West',
  ],
  Thailand: [
    'Amnat Charoen',
    'Ang Thong',
    'Buriram',
    'Chachoengsao',
    'Chai Nat',
    'Chaiyaphum',
    'Chanthaburi',
    'Chiang Mai',
    'Chiang Rai',
    'Chon Buri',
    'Chumphon',
    'Kalasin',
    'Kamphaeng Phet',
    'Kanchanaburi',
    'Khon Kaen',
    'Krabi',
    'Krung Thep Mahanakhon (Bangkok)',
    'Lampang',
    'Lamphun',
    'Loei',
    'Lop Buri',
    'Mae Hong Son',
    'Maha Sarakham',
    'Mukdahan',
    'Nakhon Nayok',
    'Nakhon Pathom',
    'Nakhon Phanom',
    'Nakhon Ratchasima',
    'Nakhon Sawan',
    'Nakhon Si Thammarat',
    'Nan',
    'Narathiwat',
    'Nong Bua Lamphu',
    'Nong Khai',
    'Nonthaburi',
    'Pathum Thani',
    'Pattani',
    'Phangnga',
    'Phatthalung',
    'Phayao',
    'Phetchabun',
    'Phetchaburi',
    'Phichit',
    'Phitsanulok',
    'Phra Nakhon Si Ayutthaya',
    'Phrae',
    'Phuket',
    'Prachin Buri',
    'Prachuap Khiri Khan',
    'Ranong',
    'Ratchaburi',
    'Rayong',
    'Roi Et',
    'Sa Kaeo',
    'Sakon Nakhon',
    'Samut Prakan',
    'Samut Sakhon',
    'Samut Songkhram',
    'Sara Buri',
    'Satun',
    'Sing Buri',
    'Sisaket',
    'Songkhla',
    'Sukhothai',
    'Suphan Buri',
    'Surat Thani',
    'Surin',
    'Tak',
    'Trang',
    'Trat',
    'Ubon Ratchathani',
    'Udon Thani',
    'Uthai Thani',
    'Uttaradit',
    'Yala',
    'Yasothon',
  ],
  'East Timor': ['Tobago'],
  Togo: ['De La Kara', 'Des Plateaux', 'Des Savanes', 'Du Centre', 'Maritime'],
  Tokelau: ['Atafu', 'Fakaofo', 'Nukunonu'],
  Tonga: ["Ha'apai", 'Tongatapu', "Vava'u"],
  'Trinidad and Tobago': [
    'Arima',
    'Caroni',
    'Mayaro',
    'Nariva',
    'Port-of-Spain',
    'Saint Andrew',
    'Saint David',
    'Saint George',
    'Saint Patrick',
    'San Fernando',
    'Victoria',
  ],
  Tunisia: [
    'Ariana',
    'Beja',
    'Ben Arous',
    'Bizerte',
    'El Kef',
    'Gabes',
    'Gafsa',
    'Jendouba',
    'Kairouan',
    'Kasserine',
    'Kebili',
    'Mahdia',
    'Medenine',
    'Monastir',
    'Nabeul',
    'Sfax',
    'Sidi Bou Zid',
    'Siliana',
    'Sousse',
    'Tataouine',
    'Tozeur',
    'Tunis',
    'Zaghouan',
  ],
  Turkey: [
    'Adana',
    'Adiyaman',
    'Afyon',
    'Agri',
    'Aksaray',
    'Amasya',
    'Ankara',
    'Antalya',
    'Ardahan',
    'Artvin',
    'Aydin',
    'Balikesir',
    'Bartin',
    'Batman',
    'Bayburt',
    'Bilecik',
    'Bingol',
    'Bitlis',
    'Bolu',
    'Burdur',
    'Bursa',
    'Canakkale',
    'Cankiri',
    'Corum',
    'Denizli',
    'Diyarbakir',
    'Duzce',
    'Edirne',
    'Elazig',
    'Erzincan',
    'Erzurum',
    'Eskisehir',
    'Gaziantep',
    'Giresun',
    'Gumushane',
    'Hakkari',
    'Hatay',
    'Icel',
    'Igdir',
    'Isparta',
    'Istanbul',
    'Izmir',
    'Kahramanmaras',
    'Karabuk',
    'Karaman',
    'Kars',
    'Kastamonu',
    'Kayseri',
    'Kilis',
    'Kirikkale',
    'Kirklareli',
    'Kirsehir',
    'Kocaeli',
    'Konya',
    'Kutahya',
    'Malatya',
    'Manisa',
    'Mardin',
    'Mugla',
    'Mus',
    'Nevsehir',
    'Nigde',
    'Ordu',
    'Osmaniye',
    'Rize',
    'Sakarya',
    'Samsun',
    'Sanliurfa',
    'Siirt',
    'Sinop',
    'Sirnak',
    'Sivas',
    'Tekirdag',
    'Tokat',
    'Trabzon',
    'Tunceli',
    'Usak',
    'Van',
    'Yalova',
    'Yozgat',
    'Zonguldak',
  ],
  Turkmenistan: [
    'Ahal Welayaty',
    'Balkan Welayaty',
    'Dashhowuz Welayaty',
    'Lebap Welayaty',
    'Mary Welayaty',
  ],
  Tuvalu: ['Tuvalu'],
  Uganda: [
    'Adjumani',
    'Apac',
    'Arua',
    'Bugiri',
    'Bundibugyo',
    'Bushenyi',
    'Busia',
    'Gulu',
    'Hoima',
    'Iganga',
    'Jinja',
    'Kabale',
    'Kabarole',
    'Kalangala',
    'Kampala',
    'Kamuli',
    'Kapchorwa',
    'Kasese',
    'Katakwi',
    'Kibale',
    'Kiboga',
    'Kisoro',
    'Kitgum',
    'Kotido',
    'Kumi',
    'Lira',
    'Luwero',
    'Masaka',
    'Masindi',
    'Mbale',
    'Mbarara',
    'Moroto',
    'Moyo',
    'Mpigi',
    'Mubende',
    'Mukono',
    'Nakasongola',
    'Nebbi',
    'Ntungamo',
    'Pallisa',
    'Rakai',
    'Rukungiri',
    'Sembabule',
    'Soroti',
    'Tororo',
  ],
  Ukraine: [
    "Avtonomna Respublika Krym (Simferopol')",
    "Cherkas'ka (Cherkasy)",
    "Chernihivs'ka (Chernihiv)",
    "Chernivets'ka (Chernivtsi)",
    "Dnipropetrovs'ka (Dnipropetrovs'k)",
    "Donets'ka (Donets'k)",
    "Ivano-Frankivs'ka (Ivano-Frankivs'k)",
    "Kharkivs'ka (Kharkiv)",
    "Khersons'ka (Kherson)",
    "Khmel'nyts'ka (Khmel'nyts'kyy)",
    "Kirovohrads'ka (Kirovohrad)",
    'Kyyiv',
    "Kyyivs'ka (Kiev)",
    "L'vivs'ka (L'viv)",
    "Luhans'ka (Luhans'k)",
    "Mykolayivs'ka (Mykolayiv)",
    "Odes'ka (Odesa)",
    "Poltavs'ka (Poltava)",
    "Rivnens'ka (Rivne)",
    "Sevastopol'",
    "Sums'ka (Sumy)",
    "Ternopil's'ka (Ternopil')",
    "Vinnyts'ka (Vinnytsya)",
    "Volyns'ka (Luts'k)",
    "Zakarpats'ka (Uzhhorod)",
    "Zaporiz'ka (Zaporizhzhya)",
    "Zhytomyrs'ka (Zhytomyr)",
  ],
  'United Arab Emirates': [
    "'Ajman",
    'Abu Zaby (Abu Dhabi)',
    'Al Fujayrah',
    'Ash Shariqah (Sharjah)',
    'Dubayy (Dubai)',
    "Ra's al Khaymah",
    'Umm al Qaywayn',
  ],
  'United Kingdom': [
    'Aberdeen City',
    'Aberdeenshire',
    'Angus',
    'Argyll and Bute',
    'Barking and Dagenham',
    'Barnet',
    'Barnsley',
    'Bath and North East Somerset',
    'Bedfordshire',
    'Bexley',
    'Birmingham',
    'Blackburn with Darwen',
    'Blackpool',
    'Blaenau Gwent',
    'Bolton',
    'Bournemouth',
    'Bracknell Forest',
    'Bradford',
    'Brent',
    'Bridgend',
    'Brighton and Hove',
    'Bromley',
    'Buckinghamshire',
    'Bury',
    'Caerphilly',
    'Calderdale',
    'Cambridgeshire',
    'Camden',
    'Cardiff',
    'Carmarthenshire',
    'Ceredigion',
    'Cheshire',
    'City of Bristol',
    'City of Edinburgh',
    'City of Kingston upon Hull',
    'City of London',
    'Clackmannanshire',
    'Conwy',
    'Cornwall',
    'Coventry',
    'Croydon',
    'Cumbria',
    'Darlington',
    'Denbighshire',
    'Derby',
    'Derbyshire',
    'Devon',
    'Doncaster',
    'Dorset',
    'Down',
    'Dudley',
    'Dumfries and Galloway',
    'Dundee City',
    'Durham',
    'Ealing',
    'East Ayrshire',
    'East Dunbartonshire',
    'East Lothian',
    'East Renfrewshire',
    'East Riding of Yorkshire',
    'East Sussex',
    'Eilean Siar (Western Isles)',
    'Enfield',
    'Essex',
    'Falkirk',
    'Fife',
    'Flintshire',
    'Gateshead',
    'Glasgow City',
    'Gloucestershire',
    'Greenwich',
    'Gwynedd',
    'Hackney',
    'Halton',
    'Hammersmith and Fulham',
    'Hampshire',
    'Haringey',
    'Harrow',
    'Hartlepool',
    'Havering',
    'Herefordshire',
    'Hertfordshire',
    'Highland',
    'Hillingdon',
    'Hounslow',
    'Inverclyde',
    'Isle of Anglesey',
    'Isle of Wight',
    'Islington',
    'Kensington and Chelsea',
    'Kent',
    'Kingston upon Thames',
    'Kirklees',
    'Knowsley',
    'Lambeth',
    'Lancashire',
    'Leeds',
    'Leicester',
    'Leicestershire',
    'Lewisham',
    'Lincolnshire',
    'Liverpool',
    'Luton',
    'Manchester',
    'Medway',
    'Merthyr Tydfil',
    'Merton',
    'Middlesbrough',
    'Midlothian',
    'Milton Keynes',
    'Monmouthshire',
    'Moray',
    'Neath Port Talbot',
    'Newcastle upon Tyne',
    'Newham',
    'Newport',
    'Norfolk',
    'North Ayrshire',
    'North East Lincolnshire',
    'North Lanarkshire',
    'North Lincolnshire',
    'North Somerset',
    'North Tyneside',
    'North Yorkshire',
    'Northamptonshire',
    'Northumberland',
    'Nottingham',
    'Nottinghamshire',
    'Oldham',
    'Orkney Islands',
    'Oxfordshire',
    'Pembrokeshire',
    'Perth and Kinross',
    'Peterborough',
    'Plymouth',
    'Poole',
    'Portsmouth',
    'Powys',
    'Reading',
    'Redbridge',
    'Redcar and Cleveland',
    'Renfrewshire',
    'Rhondda Cynon Taff',
    'Richmond upon Thames',
    'Rochdale',
    'Rotherham',
    'Rutland',
    'Salford',
    'Sandwell',
    'Sefton',
    'Sheffield',
    'Shetland Islands',
    'Shropshire',
    'Slough',
    'Solihull',
    'Somerset',
    'South Ayrshire',
    'South Gloucestershire',
    'South Lanarkshire',
    'South Tyneside',
    'Southampton',
    'Southend-on-Sea',
    'Southwark',
    'St. Helens',
    'Staffordshire',
    'Stirling',
    'Stockport',
    'Stockton-on-Tees',
    'Stoke-on-Trent',
    'Suffolk',
    'Sunderland',
    'Surrey',
    'Sutton',
    'Swansea',
    'Swindon',
    'Tameside',
    'Telford and Wrekin',
    'The Scottish Borders',
    'The Vale of Glamorgan',
    'Thurrock',
    'Torbay',
    'Torfaen',
    'Tower Hamlets',
    'Trafford',
    'Wakefield',
    'Walsall',
    'Waltham Forest',
    'Wandsworth',
    'Warrington',
    'Warwickshire',
    'West Berkshire',
    'West Dunbartonshire',
    'West Lothian',
    'West Sussex',
    'Westminster',
    'Wigan',
    'Wiltshire',
    'Windsor and Maidenhead',
    'Wirral',
    'Wokingham',
    'Wolverhampton',
    'Worcestershire',
    'Wrexham',
    'York',
  ],
  'United States': {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  },
  Uruguay: [
    'Artigas',
    'Canelones',
    'Cerro Largo',
    'Colonia',
    'Durazno',
    'Flores',
    'Florida',
    'Lavalleja',
    'Maldonado',
    'Montevideo',
    'Paysandu',
    'Rio Negro',
    'Rivera',
    'Rocha',
    'Salto',
    'San Jose',
    'Soriano',
    'Tacuarembo',
    'Treinta y Tres',
  ],
  Uzbekistan: [
    'Andijon Wiloyati',
    'Bukhoro Wiloyati',
    'Farghona Wiloyati',
    'Jizzakh Wiloyati',
    'Khorazm Wiloyati (Urganch)',
    'Namangan Wiloyati',
    'Nawoiy Wiloyati',
    'Qashqadaryo Wiloyati (Qarshi)',
    'Qoraqalpoghiston (Nukus)',
    'Samarqand Wiloyati',
    'Sirdaryo Wiloyati (Guliston)',
    'Surkhondaryo Wiloyati (Termiz)',
    'Toshkent Shahri',
    'Toshkent Wiloyati',
  ],
  Vanuatu: ['Malampa', 'Penama', 'Sanma', 'Shefa', 'Tafea', 'Torba'],
  Venezuela: [
    'Amazonas',
    'Anzoategui',
    'Apure',
    'Aragua',
    'Barinas',
    'Bolivar',
    'Carabobo',
    'Cojedes',
    'Delta Amacuro',
    'Dependencias Federales',
    'Distrito Federal',
    'Falcon',
    'Guarico',
    'Lara',
    'Merida',
    'Miranda',
    'Monagas',
    'Nueva Esparta',
    'Portuguesa',
    'Sucre',
    'Tachira',
    'Trujillo',
    'Vargas',
    'Yaracuy',
    'Zulia',
  ],
  Vietnam: [
    'An Giang',
    'Ba Ria-Vung Tau',
    'Bac Giang',
    'Bac Kan',
    'Bac Lieu',
    'Bac Ninh',
    'Ben Tre',
    'Binh Dinh',
    'Binh Duong',
    'Binh Phuoc',
    'Binh Thuan',
    'Ca Mau',
    'Can Tho',
    'Cao Bang',
    'Da Nang',
    'Dac Lak',
    'Dong Nai',
    'Dong Thap',
    'Gia Lai',
    'Ha Giang',
    'Ha Nam',
    'Ha Noi',
    'Ha Tay',
    'Ha Tinh',
    'Hai Duong',
    'Hai Phong',
    'Ho Chi Minh',
    'Hoa Binh',
    'Hung Yen',
    'Khanh Hoa',
    'Kien Giang',
    'Kon Tum',
    'Lai Chau',
    'Lam Dong',
    'Lang Son',
    'Lao Cai',
    'Long An',
    'Nam Dinh',
    'Nghe An',
    'Ninh Binh',
    'Ninh Thuan',
    'Phu Tho',
    'Phu Yen',
    'Quang Binh',
    'Quang Nam',
    'Quang Ngai',
    'Quang Ninh',
    'Quang Tri',
    'Soc Trang',
    'Son La',
    'Tay Ninh',
    'Thai Binh',
    'Thai Nguyen',
    'Thanh Hoa',
    'Thua Thien-Hue',
    'Tien Giang',
    'Tra Vinh',
    'Tuyen Quang',
    'Vinh Long',
    'Vinh Phuc',
    'Yen Bai',
  ],
  'Wallis and Futuna': ['Alo', 'Sigave', 'Wallis'],
  'Western Sahara': ['Western Sahara'],
  Yemen: [
    "'Adan",
    "'Ataq",
    'Abyan',
    "Al Bayda'",
    'Al Hudaydah',
    'Al Jawf',
    'Al Mahrah',
    'Al Mahwit',
    'Dhamar',
    'Hadhramawt',
    'Hajjah',
    'Ibb',
    'Lahij',
    "Ma'rib",
    "Sa'dah",
    "San'a'",
    "Ta'izz",
  ],
  Zambia: [
    'Central',
    'Copperbelt',
    'Eastern',
    'Luapula',
    'Lusaka',
    'North-Western',
    'Northern',
    'Southern',
    'Western',
  ],
  Zimbabwe: [
    'Bulawayo',
    'Harare',
    'ManicalandMashonaland Central',
    'Mashonaland East',
    'Mashonaland',
  ],
};
